import styles_Searchbar from '../components/Searchbar.module.scss'
import styles_DropdownMenu from '../components/DropdownMenu.module.scss'
import styles from './OrderDetail.module.scss'
import '../scss/datepicker.scss'
import { Fragment, ReactElement, forwardRef, useCallback, useEffect, useMemo, useRef, useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleRight, faGem, faFileLines as faFileLinesSolid, faPercent } from '@fortawesome/free-solid-svg-icons'
import { faHandHoldingBox, faFilePen, faShelves, faGem as faGemProSolid, faPenField, faPen, faBox, faLinkHorizontalSlash, faSignature as faSignatureBold, faScaleBalanced, faObjectGroup, faRecycle } from '@fortawesome/pro-solid-svg-icons'
import {
   faBadgeCheck,
   faFilePdf,
   faClone,
   faCloudArrowUp,
   faSignature,
   faTrashCan,
   faPenToSquare,
   faFileLines,
   faHandHoldingBox as faHandHoldingBoxProLight,
   faFilePen as faFilePenProLight,
   faShelves as faShelvesProLight,
   faGem as faGemProLight,
   faRecycle as faRecycleProLight,
   faBox as faBoxProLight,
   faArrowRight,
   faLock,
   faLockOpen,
   faFileCsv,
   faFileExcel,
   faFileImport,
   faObjectGroup as faObjectGroupProLight,
   faCircleXmark,
   faPercent as faPercentLight,
   faFloppyDisk,
   faRotateLeft,
} from '@fortawesome/pro-light-svg-icons'
import { faTag, faMemo } from '@fortawesome/pro-regular-svg-icons'
import { faCloud, faCloudXmark, faTrashXmark, faUserMagnifyingGlass } from '@fortawesome/pro-solid-svg-icons'
import DatePicker, { registerLocale, setDefaultLocale } from 'react-datepicker'
import { fr, enUS } from 'date-fns/locale'
import DropdownMenu from '../components/DropdownMenu'
import Menu from '../components/Menu/Menu'
import Searchbar from '../components/Searchbar'
import CommentEditor from '../components/CommentEditor'
import QuotaMarkEditor from '../components/QuotaMarkEditor'
import KTMDeployer from '../components/KTMDeployer'
import ProgressPopup from '../components/ProgressPopup'
import DiscountEditor from '../components/DiscountEditor'
import MailAddressPicker from '../components/MailAddressPicker'
import AddressPicker from '../components/AddressPicker'
import Button from '../components/Button'
import Link from '../components/Link'
import QtyPicker from '../components/QtyPicker'
import QtyPickerRetail from '../components/QtyPickerRetail'
// import DatePicker from '../components/DatePicker'
import Confirm from '../components/Confirm'
import { resolveRetailTableMode } from '../libs/retailTableMode'
import RetailValidationTable, { type RetailValidationTableHandle } from '../components/RetailValidation/RetailValidationTable'
import { parseSkuQtyInput } from '@/libs/skuQtyInput'
import ReliquatConfirm from '../components/RetailValidation/ReliquatConfirm'
import { Checkbox, States as CheckboxStates } from '../components/Checkbox'
import Signature from '../components/Signature'
import usePrefStore from '../stores/prefs'
import useHelpers from '../Hooks/useHelpers'
import useTranslation from '../Hooks/useTranslation'
import useSales from '../Hooks/useSales'
import useIsRetailOnly from '../Hooks/useIsRetailOnly'
import useTarifs from '../Hooks/useTarifs'
import useCollections from '../Hooks/useCollections'
import useRetailCollections from '../Hooks/useRetailCollections'
import useFinalValidation from '../Hooks/useFinalValidation'
import useReturnToClient from '../Hooks/useReturnToClient'
import useSubmitOrder from '../Hooks/useSubmitOrder'
import useRetailRoleForCustomer from '../Hooks/useRetailRoleForCustomer'
import useStock, { type StockResult } from '../Hooks/useStock'
import { getRetailStockDepots } from '../libs/retailStockDepots'
import { useSearchParams } from 'react-router-dom'
// import { useLogger } from '../Contexts/Logger';
// import { useState } from "react"
import { useLiveQuery } from 'dexie-react-hooks'
import { useNavigate } from 'react-router-dom'
import moment from 'moment'
import { CatalogFilterContext } from '../Contexts/CatalogFilterContext'
import { RetailCatalogFilterContext } from '../Contexts/RetailCatalogFilterContext'
import { GlobalContext } from '../Contexts/GlobalContext'
import { ToastContainer, toast } from 'react-toastify'
import { reportSkuVariantGuard, type SkuVariantGuardEntry } from '../libs/skuVariantGuardToast'
import { AppWriteContext } from '../Contexts/AppWriteContext'
import glob_const from '../libs/glob_const'
import { TRI_TYPE, canConvertOrderType, convertLinesForType, splitLinesToUnit } from '../libs/triOrder'
import { getStoredDiscount } from '../libs/retail_rules'
import useRetailQuota, { mergeKTMIntoKOTLines } from '../Hooks/useRetailQuota'
import type { KTMDeployOptions } from '../Hooks/useRetailQuota'
import type { Customer, Order, OrderLine } from '../types'
import { exportKOTToCSV, exportKOTToExcel, importKOTFile, validateKOTLines } from '../libs/kotExportImport'

const menu_items = {
   setActive: 'active',
   sendPdf: 'sendpdf',
   doClone: 'duplicate',
   doDeployKTM: 'deploy_ktm',
   doUnDeployKTM: 'undeploy_ktm',
   doBulkDiscount: 'bulk_discount',
   doSync: 'sync',
   doDelete: 'delete',
   doSign: 'sign',
   doValidateN2: 'validate_n2',
   doValidateN1: 'validate_n1',
   doUnlock: 'unlock',
   doSendToClient: 'send_to_client',
   exportJSON: 'export_json',
   importJSON: 'import_json',
   exportCSV: 'export_csv',
   exportExcel: 'export_excel',
   importFile: 'import_file',
}

const line_menu_items = {
   doEdit: 'edit',
   doDelete: 'delete',
   doViewInCatalog: 'catalog'
}

const confirm_type = {
   conf_delete_line: 'del_line',
   conf_delete_order: 'del_order'
}

const search_type = {
   in_catalog: 'in_catalog',
   in_order: 'in_order',
   manu_sku: 'manu_sku'
}

registerLocale('fr', fr)
registerLocale('en-US', enUS)
setDefaultLocale('fr')

const toastSuccessOptions = {
   position: 'top-right' as const,
   autoClose: 2500,
   hideProgressBar: false,
   closeOnClick: true,
   pauseOnHover: true,
   draggable: true,
   theme: 'colored' as const,
}

function OrderDetail() {
   // // const allOrders = usePrefStore((state) => state.orders);
   // // const setAllOrders = usePrefStore((state) => state.setOrders);
   // const curOrder = usePrefStore((state) => state.curOrder);
   // const curLang = usePrefStore((state) => state.currentLang)
   // const showWeeksNum = usePrefStore((state) => state.showWeeksNum)
   // const searchModeInOrder = usePrefStore((state) => state.searchModeInOrder)
   // const setSearchModeInOrder = usePrefStore((state) => state.setSearchModeInOrder)
   // const setCurOrder = usePrefStore((state) => state.setCurOrder);
   const { curOrder, currentLang: curLang, showWeeksNum, searchModeInOrder, setSearchModeInOrder, setCurOrder, retailRole, isRetailManager, curTarifRegionName, curTarifRegion } = usePrefStore()
   //
   const { isDarkLayerVisible, setIsDarkLayerVisible, setKeepSearchBarAccessible } = { ...GlobalContext() } as any
   //
   const [searchBar, setSearchBar] = useState<ReactElement | null>(null)
   const [searchText, setSearchText] = useState<string | null>(null)
   const [filteredLines, setFilteredLines] = useState<OrderLine[] | undefined>(undefined)
   const [lines, setLines] = useState<ReactElement[] | null>(null)
   // const [order, setOrder] = useState(null)
   const [customer, setCustomer] = useState<Customer | null>(null)
   const [region, setRegion] = useState(null) // On n'est pas forcément sur le client ou la commande sélectionné(e), on va avoir besoin de spécifier la devise d'affichage
   const [currency, setCurrency] = useState<string | null>(null) // Devise CESSION (CES) — prix retail (ECR/ECF) ET commandes classiques (tout est valorisé en cession)
   const [retailQuotas, setRetailQuotas] = useState<Map<string, { budgeted: number, consumed: number, remaining: number }>>(new Map())
   const [hasActiveKOT, setHasActiveKOT] = useState(false)
   const [isValidationMode, setIsValidationMode] = useState(false)
   const [isDraftMode, setIsDraftMode] = useState(false)   // brouillon new_mgr N1/admin affiché dans RetailValidationTable
   const [showDropdownMenuGlobal, setShowDropdownMenuGlobal] = useState(false)
   const [dropdownMenuGlobal, setDropdownMenuGlobal] = useState<ReactElement | null>(null)
   const [dropdownMenuLine, setDropdownMenuLine] = useState<ReactElement | null>(null)
   const [showDropdownMenuOnLineNum, setShowDropdownMenuOnLineNum] = useState<number | null>(null)
   const [lastSelectedLineNum, setLastSelectedLineNum] = useState<number | null>(null) // Sert lors de la màj d'une ligne pour savoir quelle ligne a été choisie
   const [isQtyPickerVisible, setIsQtyPickerVisible] = useState(false) //16
   const [isAddressPickerVisible, setIsAddressPickerVisible] = useState(false)
   const [isConfirmVisible, setIsConfirmVisible] = useState(false)
   const [duplicateLineDialog, setDuplicateLineDialog] = useState<{ line: OrderLine, existingQty: number } | null>(null)
   const [isLineDiscountEditorVisible, setIsLineDiscountEditorVisible] = useState(false)
   const [isBulkDiscountEditorVisible, setIsBulkDiscountEditorVisible] = useState(false)
   const [importJSONOrder, setImportJSONOrder] = useState<Order | null>(null)
   const validationTableRef = useRef<RetailValidationTableHandle>(null)
   // Restauration de sauvegarde : le brouillon de RetailValidationTable n'est construit qu'au montage.
   // On mémorise les lignes restaurées, puis on remonte la table (key) dès que live_order les reflète.
   const [pendingRestoreLines, setPendingRestoreLines] = useState<OrderLine[] | null>(null)
   const [validationTableKey, setValidationTableKey] = useState(0)
   const jsonImportRef = useRef<HTMLInputElement>(null)
   const [editedLineDiscount, setEditedLineDiscount] = useState<number | null>(null)
   const [isSignatureVisible, setIsSignatureVisible] = useState(false)
   // const [isEditingComment, setIsEditingComment] = useState(false)
   const [confirmType, setConfirmType] = useState<string | null>(null)
   const [editedLineNum, setEditedLineNum] = useState<number | null>(null) // N° de la ligne en cours d'édition
   const [editedSKU, setEditedSKU] = useState<string | null>(null) // SKU Modèle de la ligne en cours d'édition (pour retail seulement)
   const [editedModel, setEditedModel] = useState<string | null>(null) // ID Modèle de la ligne en cours d'édition
   const [editedColor, setEditedColor] = useState<string | null>(null) // Couleur de la ligne en cours d'édition
   const [editedSize, setEditedSize] = useState<string | null>(null) // Taille de la ligne en cours d'édition
   const [editedQty, setEditedQty] = useState<number | null>(null) // Quantité de la ligne en cours d'édition
   const [editedLineComment, setEditedLineComment] = useState<string | null>(null) // Commentaire ligne en cours d'édition
   const [searchId, setSearchId] = useState<string | null>(null) // ID passé en param sur URL
   const [editedAllVariations, setEditedAllVariations] = useState<{ color: string; size: string; qty: number }[] | null>(null) // Toutes les variations de couleur+taille présentes dans la commande pour le modèle  de la ligne en cours d'édition. Utile pour le QtyPicker en mode multi
   const [totalForOrder, setTotalForOrder] = useState<number | undefined>()
   const [itemsCountForOrder, setItemsCountForOrder] = useState<number | undefined>()
   const [dropdownMenuOrderType, setDropdownMenuOrderType] = useState<ReactElement | undefined>()
   const [isMenuOrderTypeVisible, setIsMenuOrderTypeVisible] = useState(false)
   const [isContremarqueEditorVisible, setIsContremarqueEditorVisible] = useState(false)
   const [isQuotaCloneEditorVisible, setIsQuotaCloneEditorVisible] = useState(false)
   const [showKtmDeployer, setShowKtmDeployer] = useState(false)
   const [unDeployKtm, setUnDeployKtm] = useState<Order | null>(null)
   const [unDeployAffected, setUnDeployAffected] = useState<Customer[]>([])
   const [unDeployCheckedIds, setUnDeployCheckedIds] = useState<string[]>([])
   const [deployProgress, setDeployProgress] = useState<{ label: string; done: number; total: number } | null>(null)
   const [isCommentEditorVisible, setIsCommentEditorVisible] = useState(false)
   const [isMailAddressPickerVisible, setIsMailAddressPickerVisible] = useState(false)
   const [isLineCommentEditorVisible, setIsLineCommentEditorVisible] = useState(false)
   const [isReadOnly, setIsReadOnly] = useState(false)
   const [showValidateConfirm, setShowValidateConfirm] = useState(false)
   const [validateMode, setValidateMode] = useState<'n1' | 'n2' | null>(null)
   const [refusedLinesForPopup, setRefusedLinesForPopup] = useState<{ sku: string; label: string; origQty: number; curQty: number; reliquat: number }[]>([])
   const [checkedRefusedLines, setCheckedRefusedLines] = useState<boolean[]>([])
   const [isSelected, setIsSelected] = useState(false)
   const [isProspect, setIsProspect] = useState(false)
   const [showImportModeConfirm, setShowImportModeConfirm] = useState(false)
   const [pendingImportLines, setPendingImportLines] = useState<{ sku: string; qty: number }[]>([])
   const [importOptReplace, setImportOptReplace] = useState(true)
   const [importOptCumul, setImportOptCumul] = useState(false)
   const fileInputRef = useRef<HTMLInputElement>(null)
   //
   const {
      order_status,
      createOrUpdateLinesInOrder,
      setOrderIdAsCurrent,
      selectCustomerWithTarif,
      getOrderById,
      getCustomerById,
      deleteSingleLineInOrder,
      deleteOrder,
      updateOrder,
      updateOrderLocally,
      type_order,
      calcTotalForOrder,
      getItemsCountForOrder,
      cloneOrder,
      canSyncOrder,
      isOrderComplete,
      canWriteKOT,
      isRetailOrder,
      getEffectiveRetailRole,
      hasN1Validator,
      isKOTOrder,
      isKTMOrder,
      getRetailOrderType,
      computeRefusedLines,
      submitRetailOrder,
      validateRetailN2,
      validateRetailN1,
      returnRetailToClient,
      sendRetailToClient,
      createOrder,
      makeTemplateOrder,
      getCustomersAsSortedArray,
      getUnsyncOrdersAsArray,
      isOrderSubmittedOrLocked
   } = useSales()
   const isKOTOrKTM = useCallback((order: any) => isKOTOrder(order) || isKTMOrder(order), [isKOTOrder, isKTMOrder])
   const { KOT_MARK_PREFIX, getRetailQuota, formatSkuRemaining, canCreateKTM, extractPeriodFromKTMMark, extractClientTypeFromKTMMark, findKOTByPeriod } = useRetailQuota()
   const { getModelById, makeSKU, splitSKU } = useCollections()
   const { getRetailModelById } = useRetailCollections()
   const isRetailOnly = useIsRetailOnly()
   const { requestFinalValidation, finalValidationPopups } = useFinalValidation({ validateRetailN1, computeRefusedLines, isRetailOrder, getRetailModelById })
   const { requestReturnToClient, returnToClientPopups } = useReturnToClient({ sendRetailToClient, returnRetailToClient, newMgrStatus: order_status.new_mgr })
   const { requestSubmit, submitPopups } = useSubmitOrder({ submitRetailOrder, updateOrder, isRetailOrder, lockedForSyncStatus: order_status.locked4sync })
   const { getCessPriceForModelColorSize, getCessPriceForModelBySKU, getMinMaxCessPriceForModel, findRegionFromCessionTarifNames, findRegionFromPublicTarifNames, sanitizeSkuVariant } = useTarifs()
   //
   const { formatCESPrice, formatNumber, formatLength, formatRetailWeightWithNC, formatRetailPrice } = useHelpers()
   const { trans, lowtrans, transWithParams } = useTranslation()
   const { clearAllFilters, setSearchText: setCatalogSearchText } = CatalogFilterContext()
   const { setSearchText: setCatalogRetailSearchText, clearAllFilters: clearAllRetailFilters } = RetailCatalogFilterContext()
   const { awPushPDF, currentUserId } = { ...AppWriteContext() } as any
   const [searchParams] = useSearchParams()
   const live_order = useLiveQuery(async () => {
      setFilteredLines(undefined) // Pour éviter d'afficher les lignes de la commande préc qui ne serait pas du mm type (Bjx vs Retail) et provoquerait un crash entre getModelById() et getRetailModelById() au refresh entre les 2 cdes
      return await getOrderById(searchId)
   }, [searchId])
   const live_unsync_orders = useLiveQuery(getUnsyncOrdersAsArray)
   const existingKTMMarks = useMemo(() => {
      return live_unsync_orders?.filter(o => o.type === type_order.ktm_quota && o.mark && o.id !== searchId).map(o => o.mark!) ?? []
   }, [live_unsync_orders, type_order.ktm_quota, searchId])
   const existingKOTMarksForCustomer = useMemo(() => {
      const customerId = (live_unsync_orders ?? []).find(o => o.id === searchId)?.customer_id
      if (!customerId) return []
      return (live_unsync_orders ?? [])
         .filter(o => o.type === type_order.retail_quota && o.mark && o.customer_id === customerId && o.id !== searchId)
         .map(o => o.mark!)
   }, [live_unsync_orders, type_order.retail_quota, searchId])
   const navigate = useNavigate()

   const CustomDate = forwardRef<any, any>((props, ref) => {
      return (
         <span onClick={props.onClick} ref={ref}>
            {props.text}
         </span>
      )
   })

   useEffect(() => {
      setIsSelected(curOrder && curOrder === live_order?.id)
      // Tableau de validation/brouillon affiché : le crayon reste disponible même hors commande courante
      const penAllowed = !isReadOnly && !!live_order && (curOrder === live_order?.id || isValidationMode)
      if (!searchModeInOrder || (searchModeInOrder === search_type.manu_sku && !penAllowed)) {
         setSearchModeInOrder(search_type.in_catalog)
      }
   }, [curOrder, isReadOnly, isValidationMode, live_order, searchModeInOrder, setSearchModeInOrder])

   // À l'ouverture du tableau, la barre du haut passe d'office en mode crayon (ajout par SKU)
   const penAutoSetRef = useRef(false)
   useEffect(() => {
      if (!isValidationMode) { penAutoSetRef.current = false; return }
      if (penAutoSetRef.current || isReadOnly || !live_order) return
      penAutoSetRef.current = true
      setSearchModeInOrder(search_type.manu_sku)
   }, [isValidationMode, isReadOnly, live_order, setSearchModeInOrder])

   useEffect(() => {
      setSearchId(searchParams.get('id'))
   }, [searchParams])

   useEffect(() => {
      setTotalForOrder(calcTotalForOrder(live_order))
      setItemsCountForOrder(getItemsCountForOrder(live_order))
   }, [calcTotalForOrder, getItemsCountForOrder, live_order])

   // Charge les quotas du client de la commande pour afficher le restant par ligne (ECR/ECF/KOT/KTM)
   useEffect(() => {
      let cancelled = false
      if (live_order && (isRetailOrder(live_order) || isKOTOrKTM(live_order))) {
         getRetailQuota(live_order.customer_id, live_order.id).then(result => {
            if (!cancelled) {
               setRetailQuotas(result.skuQuotas)
               setHasActiveKOT(result.kotOrder !== null)
            }
         })
      } else {
         setRetailQuotas(new Map())
         setHasActiveKOT(false)
      }
      return () => { cancelled = true }
   }, [live_order, isRetailOrder, isKOTOrKTM, getRetailQuota])

   // Rôle vis-à-vis du customer de cette commande (admin/N1/N2 per-customer) —
   // utilisé en fallback de getEffectiveRetailRole et pour les actions au niveau
   // de l'order sans dépendre du retailRole global.
   const roleForOrder = useRetailRoleForCustomer(live_order?.customer_id)

   // Colonne stock permanente (mode édition normal, hors validation N1/N2) : mêmes dépôts
   // que le picker de quantité pour le rôle courant (cf. getRetailStockDepots).
   const { fetchStock } = useStock()
   const stockDepots = useMemo<string[]>(
      () => getRetailStockDepots(roleForOrder, customer?.depot_retail ?? null),
      [roleForOrder, customer?.depot_retail],
   )
   const stockDepotsKey = stockDepots.join('|')
   const [orderLineStocks, setOrderLineStocks] = useState<Map<string, StockResult>>(new Map())

   // Préchargement du stock pour toutes les lignes (fetch auto au montage / à chaque changement
   // de lignes, même mécanisme que RetailValidationTable) — uniquement hors mode validation N1/N2,
   // qui précharge déjà lui-même via son propre effet.
   useEffect(() => {
      if (!live_order || isValidationMode || !isRetailOrder(live_order)) return
      let cancelled = false
      const toFetch: Array<{ sku: string, modelId: string }> = []
      for (const line of live_order.lines ?? []) {
         if (orderLineStocks.has(line.sku)) continue
         const modelId = getRetailModelById(line.sku)?.id ?? line.sku.split('-')[0]
         if (modelId) toFetch.push({ sku: line.sku, modelId })
      }
      if (toFetch.length === 0) return
      // Chaque fetch est isolé par .catch() : l'échec d'une ligne ne doit jamais empêcher
      // l'affichage du stock des autres lignes ni provoquer de rejet non intercepté.
      Promise.all(toFetch.map(async ({ sku, modelId }) => {
         try {
            return { sku, result: await fetchStock(modelId, stockDepots) }
         } catch {
            return null
         }
      }))
         .then(entries => {
            if (cancelled) return
            setOrderLineStocks(prev => {
               const next = new Map(prev)
               for (const entry of entries) {
                  if (entry) next.set(entry.sku, entry.result)
               }
               return next
            })
         })
      return () => { cancelled = true }
   // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [live_order, isValidationMode, isRetailOrder, stockDepotsKey, fetchStock, getRetailModelById, orderLineStocks])

   // ECF : on n'affiche la col Remise que si au moins une ligne a une remise > 0 et < 100
   // (les 100% sont rendus "Gratuit" dans la col Prix → la col Remise serait redondante).
   const hasDisplayableDiscount = useMemo(
      () => (live_order?.lines ?? []).some(l => typeof l.discount === 'number' && l.discount > 0 && l.discount < 100),
      [live_order?.lines],
   )

   useEffect(() => {
      if (live_order) {
         // console.log('++++', live_order);
         // setOrder(live_order)
         setCustomer(getCustomerById(live_order.customer_id))
         // Retail : le N2 peut modifier en wait_n2, le N1/admin peut modifier en wait_n1
         // (per-customer : on regarde le rôle vis-à-vis du customer de cet order précis)
         const canEditRetail =
            (roleForOrder.isN2 && live_order.status === order_status.wait_n2) ||
            ((roleForOrder.isN1 || roleForOrder.isAdmin) && (live_order.status === order_status.wait_n1 || live_order.status === order_status.wait_n2))
         setIsReadOnly(canEditRetail ? false : live_order.readonly)
         // Brouillon manager new_mgr ouvert par un N1/admin : même table que la validation, en mode 'draft'
         const isDraft = resolveRetailTableMode({ status: live_order.status, isRetail: isRetailOrder(live_order), isN1: roleForOrder.isN1, isN2: roleForOrder.isN2, isAdmin: roleForOrder.isAdmin }) === 'draft'
         setIsValidationMode(isDraft || (canEditRetail && isRetailOrder(live_order) && (live_order.status === order_status.wait_n1 || live_order.status === order_status.wait_n2)))
         setIsDraftMode(isDraft)
         // NB : on NE fait PAS de setOrderIdAsCurrent ici. Une commande soumise (wait_n2/wait_n1)
         // est verrouillée pour nous : la validation passe par isValidationMode + la table de
         // validation, pas par curOrder. La rendre « courante » serait contraire à l'invariant.
         // En revanche, on rattache le CONTEXTE du valideur au client de la commande : on sélectionne
         // son customer (curCustomer + tarif) et on télécharge son tarif au besoin, pour afficher les PU.
         if (canEditRetail || isDraft) {
            selectCustomerWithTarif(live_order.customer_id)
         }
         setIsProspect(live_order.customer_id.startsWith(glob_const.prefix_prospect))
      }
   }, [getCustomerById, isRetailOrder, live_order, order_status, roleForOrder, selectCustomerWithTarif])

   useEffect(() => {
      // Devise d'affichage : on n'est pas forcément sur le client ou la commande sélectionné(e)
      let a_region = findRegionFromCessionTarifNames(customer?.tarifs.ces.tarif, customer?.tarifs.ces.currency)
      if (!a_region) {
         // !!!!! NB : OUI, c'est bien CES qui est pris dans a_customer pour chercher la région. C'est pour les clients qui n'ont pas de tarif cession mais un tarif public remisé
         a_region = findRegionFromPublicTarifNames(customer?.tarifs.ces.tarif, customer?.tarifs.ces.currency)
      }
      // Fallback pour les KTM (faux client KTM_xxx sans tarif assigné) : région/devise du menu
      if (!a_region && isKTMOrder(live_order)) {
         setRegion(curTarifRegionName)
         setCurrency(curTarifRegion?.other?.ces?.currency ?? null)
         return
      }
      setRegion(a_region)
      setCurrency(customer?.tarifs.ces.currency ?? null)
   }, [customer, findRegionFromCessionTarifNames, findRegionFromPublicTarifNames, isKTMOrder, live_order, curTarifRegionName, curTarifRegion])

   const _isRetail = isRetailOrder(live_order)
   // Rôle effectif sur cet order (admin > N1 > N2 > client) — peut différer du retailRole global
   // si le user est par ex. N2 d'un client X mais N1 d'un autre client Y.
   const effectiveRetailRole = useMemo(() => getEffectiveRetailRole(live_order, currentUserId, retailRole, roleForOrder, isRetailManager), [live_order, currentUserId, retailRole, roleForOrder, isRetailManager, getEffectiveRetailRole])
   // Pictos de synchro — cas particulier du USER-CLIENT retail : on ne lui expose pas le détail
   // du workflow interne de validation (il n'a pas à savoir si sa commande est chez le N1 ou le N2).
   //   - wait_n1 / wait_n2  → loupe-user À LA PLACE du nuage, rien en dessous ("en cours d'examen")
   //   - locked / wait_m3   → nuage seul, sans le "M3" en dessous
   // Les autres rôles (admin / N1 / N2 / commercial) gardent l'affichage complet N1/N2/M3.
   // NB : basé sur le retailRole GLOBAL (le user EST un client), pas sur effectiveRetailRole.
   const hideRetailWorkflow = useMemo(() => retailRole === 'client' && _isRetail, [retailRole, _isRetail])
   const isUnderRetailReview = useMemo(() => hideRetailWorkflow && (live_order?.status === order_status.wait_n1 || live_order?.status === order_status.wait_n2), [hideRetailWorkflow, live_order?.status, order_status])
   const orderHasN1 = useMemo(() => hasN1Validator(live_order, customer), [live_order, customer, hasN1Validator])
   /** Le N2 valide directement vers M3 (= dernière étape) si aucun N1 n'est connu pour cet order. */
   const n2IsLastStep = effectiveRetailRole === 'N2' && !orderHasN1
   const _retailStatus = live_order?.status

   const onSelectGlobal = useCallback(
      async (id) => {
         setShowDropdownMenuGlobal(false)
         if (id === menu_items.setActive) {
            setOrderIdAsCurrent(live_order?.id)
         } else if (id === menu_items.doClone) {
            // Pour KOT/KTM : ouvrir d'abord l'éditeur de contremarque (la nouvelle doit être unique)
            if (isKOTOrder(live_order) || isKTMOrder(live_order)) {
               setIsQuotaCloneEditorVisible(true)
            } else {
               cloneOrder(live_order?.id).then((new_id) => {
                  setOrderIdAsCurrent(new_id)
                  navigate(`/order-detail?id=${new_id}`, { replace: false })
                  toast.success(transWithParams('?order_cloned', [new_id]), {
                     position: 'top-right',
                     autoClose: 2500,
                     hideProgressBar: false,
                     closeOnClick: true,
                     pauseOnHover: true,
                     draggable: true,
                     // progress: ,
                     theme: 'colored'
                  })
               })
            }
         } else if (id === menu_items.sendPdf) {
            setIsMailAddressPickerVisible(true)
         } else if (id === menu_items.doSync) {
            // Flux unique : popup de confirmation puis soumission (retail) / synchronisation (classique).
            requestSubmit(live_order, () => {
               if (_isRetail) {
                  setCurOrder(null)
                  navigate('/orders', { replace: true })
               }
            })
         } else if (id === menu_items.doDelete) {
            setConfirmType(confirm_type.conf_delete_order)
            setIsConfirmVisible(true)
         } else if (id === menu_items.doSign) {
            setIsSignatureVisible(true)
         } else if (id === menu_items.doValidateN2) {
            // Validation N2 → webhook validate-n2 (le serveur décide wait_n1 ou locked + pose les perms).
            // Reliquat proposé UNIQUEMENT si cette validation va en 'locked' = pas de N1 derrière
            // (sinon → wait_n1, étape intermédiaire : pas de reliquat).
            if (!orderHasN1 && live_order?.original_lines && isRetailOrder(live_order)) {
               const refused = computeRefusedLines(live_order.original_lines, live_order.lines)
               if (refused.length > 0) {
                  const currentMap = new Map(live_order.lines.map(l => [l.sku, l.qty]))
                  const origMap = new Map(live_order.original_lines.map(l => [l.sku, l.qty]))
                  setRefusedLinesForPopup(refused.map(r => ({ sku: r.sku, label: getRetailModelById(r.sku)?.label ?? '', origQty: origMap.get(r.sku) ?? 0, curQty: currentMap.get(r.sku) ?? 0, reliquat: r.qty })))
                  setCheckedRefusedLines(refused.map(() => true))
                  setValidateMode('n2')
                  setShowValidateConfirm(true)
               } else {
                  await validateRetailN2(live_order)
                  setCurOrder(null)
                  navigate('/orders?tab=unsync', { replace: true })
               }
            } else {
               await validateRetailN2(live_order)
               setCurOrder(null)
               navigate('/orders?tab=unsync', { replace: true })
            }
         } else if (id === menu_items.doValidateN1) {
            // Flux unique : confirmation (+ reliquat) puis validateRetailN1.
            requestFinalValidation(live_order, () => {
               setCurOrder(null)
               navigate('/orders?tab=unsync', { replace: true })
            })
         } else if (id === menu_items.doUnlock || id === menu_items.doSendToClient) {
            // Flux unique « Renvoyer au client » (confirmation + dispatch new_mgr / wait_n*).
            requestReturnToClient(live_order, () => {
               setCurOrder(null)
               navigate(id === menu_items.doSendToClient ? '/orders?tab=unsync' : '/orders?tab=pending', { replace: true })
            })
         } else if (id === menu_items.exportCSV) {
            if (live_order?.lines) {
               const getLabel = (sku: string) => getRetailModelById(sku)?.label ?? ''
               exportKOTToCSV(live_order.lines, getLabel, `kot-${live_order.mark ?? live_order.id}.csv`)
            }
         } else if (id === menu_items.exportExcel) {
            if (live_order?.lines) {
               const getLabel = (sku: string) => getRetailModelById(sku)?.label ?? ''
               const period = live_order.mark?.replace('QUOTAS_', '') ?? undefined
               exportKOTToExcel(live_order.lines, getLabel, period ? { period } : undefined, `kot-${live_order.mark ?? live_order.id}.xlsx`)
            }
         } else if (id === menu_items.importFile) {
            fileInputRef.current?.click()
         } else if (id === menu_items.doBulkDiscount) {
            setIsBulkDiscountEditorVisible(true)
         } else if (id === menu_items.exportJSON) {
            if (live_order) {
               const customer = getCustomerById(live_order.customer_id)
               const custName = (customer?.name ?? live_order.customer_id).replace(/[^a-zA-Z0-9_-]/g, '_').substring(0, 30)
               const now = new Date()
               const dt = `${now.getFullYear()}${String(now.getMonth() + 1).padStart(2, '0')}${String(now.getDate()).padStart(2, '0')}_${String(now.getHours()).padStart(2, '0')}${String(now.getMinutes()).padStart(2, '0')}${String(now.getSeconds()).padStart(2, '0')}`
               const filename = `${custName}_${live_order.id}_${dt}.json`
               const blob = new Blob([JSON.stringify(live_order, null, 2)], { type: 'application/json' })
               const url = URL.createObjectURL(blob)
               const a = document.createElement('a')
               a.href = url
               a.download = filename
               a.click()
               URL.revokeObjectURL(url)
               toast.success(`${trans('?Sauvegarde')} : ${filename}`, { position: 'top-right', autoClose: 2500, theme: 'colored' })
            }
         } else if (id === menu_items.importJSON) {
            jsonImportRef.current?.click()
         } else if (id === menu_items.doDeployKTM) {
            if (live_order && isKTMOrder(live_order)) {
               setShowKtmDeployer(true)
            }
         } else if (id === menu_items.doUnDeployKTM) {
            if (live_order && isKTMOrder(live_order)) {
               const clientType = extractClientTypeFromKTMMark(live_order.mark ?? null)
               const period = extractPeriodFromKTMMark(live_order.mark ?? null)
               if (!clientType || !period) {
                  toast.error(trans('?Période invalide sur le KTM'), { position: 'top-right', autoClose: 3000, theme: 'colored' })
               } else {
                  const eligible = (getCustomersAsSortedArray() as Customer[]).filter(c => {
                     if (!c.groupe_client) return false
                     if (c.id?.startsWith(glob_const.prefix_ktm) || c.id?.startsWith(glob_const.prefix_prospect)) return false
                     const grp = (glob_const.customer_groups as Record<string, { type: string }>)[c.groupe_client]
                     return grp?.type === clientType
                  })
                  const affected: Customer[] = []
                  for (const c of eligible) {
                     const kot = await findKOTByPeriod(c.id!, period)
                     if (kot) affected.push(c)
                  }
                  setUnDeployKtm(live_order)
                  setUnDeployAffected(affected)
                  setUnDeployCheckedIds(affected.map(c => c.id!))
               }
            }
         }
      },
      [_isRetail, cloneOrder, computeRefusedLines, getCustomerById, getRetailModelById, isKOTOrder, isKTMOrder, isRetailOrder, live_order, navigate, setCurOrder, setOrderIdAsCurrent, transWithParams, extractClientTypeFromKTMMark, extractPeriodFromKTMMark, findKOTByPeriod, getCustomersAsSortedArray, trans, validateRetailN2, requestReturnToClient, requestFinalValidation, requestSubmit, orderHasN1]
   )

   async function onValidateConfirmOK() {
      // Lignes refusées cochées à reporter en reliquat : transmises au webhook, qui crée le reliquat
      // côté serveur (perms client+admins) UNIQUEMENT si la validation produit 'locked'.
      const reliquatLines = refusedLinesForPopup
         .filter((_, i) => checkedRefusedLines[i])
         .map(r => ({ sku: r.sku, qty: r.reliquat }))
      if (validateMode === 'n2') {
         // N2 valide → webhook validate-n2 (le serveur décide wait_n1 ou locked + pose les perms ; reliquat si locked).
         await validateRetailN2(live_order, reliquatLines)
      } else {
         // N1 valide → webhook validate-n1 (→ locked + reliquat).
         await validateRetailN1(live_order, reliquatLines)
      }
      setShowValidateConfirm(false)
      setValidateMode(null)
      setCurOrder(null)
      navigate('/orders?tab=unsync', { replace: true })
   }

   function onValidateConfirmCancel() {
      setShowValidateConfirm(false)
      setValidateMode(null)
   }

   async function onFileInputChange(e: React.ChangeEvent<HTMLInputElement>) {
      const file = e.target.files?.[0]
      if (fileInputRef.current) fileInputRef.current.value = '' // reset pour pouvoir réimporter le même fichier
      if (!file) return
      try {
         const result = await importKOTFile(file)
         if (result.lines.length === 0) {
            toast.error(trans("?Aucune ligne valide dans le fichier"), { position: 'top-right', autoClose: 3000, theme: 'colored' })
            return
         }
         const errors = validateKOTLines(result.lines, { skuExists: (sku) => !!getRetailModelById(sku) })
         if (errors.length > 0) {
            toast.error(trans("?Import : SKU manquant, inconnu ou quantité invalide") + '\n' + errors.map(e => e.message).join('\n'), { position: 'top-right', autoClose: 5000, theme: 'colored' })
            return
         }
         setPendingImportLines(result.lines)
         setImportOptReplace(true)
         setImportOptCumul(false)
         setShowImportModeConfirm(true)
      } catch {
         toast.error(trans("?Erreur lors de la lecture du fichier"), { position: 'top-right', autoClose: 3000, theme: 'colored' })
      }
   }

   async function doImport() {
      if (!live_order) return
      setShowImportModeConfirm(false)
      if (importOptReplace) {
         // Remplacer : on écrase toutes les lignes
         const newLines: OrderLine[] = pendingImportLines.map(l => ({ sku: l.sku, qty: l.qty }))
         await updateOrder(live_order.id, { lines: newLines })
      } else if (importOptCumul) {
         // Ajouter + cumuler : additionner les qtés pour les SKU déjà présents
         const existingMap = new Map(live_order.lines.map(l => [l.sku, l.qty]))
         const mergedLines = pendingImportLines.map(l => ({
            sku: l.sku,
            qty: l.qty + (existingMap.get(l.sku) ?? 0)
         }))
         await createOrUpdateLinesInOrder(live_order.id, mergedLines)
      } else {
         // Ajouter sans cumuler : écraser la qté si SKU existe, sinon ajouter
         await createOrUpdateLinesInOrder(live_order.id, pendingImportLines.map(l => ({ sku: l.sku, qty: l.qty })))
      }
      toast.success(trans("?Fichier importé avec succès"), { position: 'top-right', autoClose: 2500, theme: 'colored' })
      setPendingImportLines([])
      setImportOptReplace(true)
      setImportOptCumul(false)
   }

   const onSelectLine = useCallback(
      (id) => {
         console.log('ID>>', id, showDropdownMenuOnLineNum)
         const selectedSKU = filteredLines ? filteredLines[showDropdownMenuOnLineNum - 1].sku : null
         const selectedQty = filteredLines ? filteredLines[showDropdownMenuOnLineNum - 1].qty : null
         const { model, color, size } = splitSKU(selectedSKU)

         setEditedLineNum(showDropdownMenuOnLineNum)
         setEditedSKU(selectedSKU)
         setEditedModel(model)
         setEditedColor(color)
         setEditedSize(size)
         setEditedQty(selectedQty)

         if (id === line_menu_items.doEdit) {
            setIsQtyPickerVisible(true)
            // setEditedAllVariations(
            const arr = filteredLines?.reduce((prev, cur_line) => {
               const { model: model2, color: color2, size: size2 } = splitSKU(cur_line.sku)
               console.log('SKU', cur_line.sku)
               console.log('MODEL ?', model2, model)
               console.log('COLOR ?', color2, color)
               console.log('SIZE ?', size2, size)
               if (model2 === model) {
                  return [...prev, { color: color2, size: size2, qty: cur_line.qty }]
               } else {
                  return [...prev]
               }
            }, [])
            // )
            console.log('>>', arr, live_order, filteredLines)
            setEditedAllVariations(arr)
         } else if (id === line_menu_items.doDelete) {
            setConfirmType(confirm_type.conf_delete_line)
            setIsConfirmVisible(true)
         } else if (id === line_menu_items.doViewInCatalog) {
            const selectedSKU = filteredLines ? filteredLines[showDropdownMenuOnLineNum - 1].sku : null
            if (selectedSKU) {
               if (isRetailOrder(live_order) || isKOTOrKTM(live_order)) {
                  setCatalogRetailSearchText(selectedSKU)
                  navigate('/retail-catalog-detail', { replace: false })
               } else {
                  const { model } = splitSKU(selectedSKU)
                  setCatalogSearchText(model)
                  navigate('/catalog-detail', { replace: false })
               }
            }
         }
         setShowDropdownMenuOnLineNum(null)
      },
      [filteredLines, isKOTOrKTM, isRetailOrder, live_order, navigate, setCatalogRetailSearchText, setCatalogSearchText, showDropdownMenuOnLineNum, splitSKU]
   )
   // }, [])

   // Pré-applique la remise par défaut sur une ligne retail :
   //  - ECR/ECF : discount stocké = getStoredDiscount(famille, customer)
   //              (mappe NF → 0, 100 → 100, 0 → 0 ; cf. retail_rules.ts).
   //              Les NF sont gratuit côté oMe (affichage) mais facturés plein côté M3.
   //  - KOT/KTM (quotas) : les prix ne servent pas (= juste pour le quota), discount=0 par défaut.
   const applyAutoDiscount = useCallback((line: OrderLine, order: Order | null | undefined): OrderLine => {
      if (line.discount != null) return line
      const isECRorECF =
         order?.type === type_order.retail_interne ||
         order?.type === type_order.retail_externe
      const isQuotaLike =
         order?.type === type_order.retail_quota ||
         order?.type === type_order.ktm_quota
      if (!isECRorECF && !isQuotaLike) return line
      if (isECRorECF) {
         const model = getRetailModelById(line.sku)
         if (!model) return line
         const stored = getStoredDiscount(model.fam, customer)
         if (stored === null) return line
         return { ...line, discount: stored }
      }
      // KOT/KTM : pas de notion de prix → discount=0 par défaut, peu importe la famille.
      return { ...line, discount: 0 }
   }, [customer, getRetailModelById, type_order.retail_interne, type_order.retail_externe, type_order.retail_quota, type_order.ktm_quota])

   /**
    * Tente d'ajouter une ligne. Si le SKU existe déjà dans la commande (hors lignes commentées),
    * ouvre un popup pour choisir entre Remplacer / Cumuler / Annuler.
    * Sinon ajoute directement avec le toast "ajouté".
    */
   const commitLineWithDuplicateCheck = useCallback(async (line: OrderLine) => {
      const existing = (live_order?.lines ?? []).find(l => l.sku === line.sku && !l.comment)
      if (existing) {
         setDuplicateLineDialog({ line, existingQty: existing.qty })
         return
      }
      const lineWithDefaults = applyAutoDiscount(line, live_order)
      await createOrUpdateLinesInOrder(live_order.id, [lineWithDefaults])
      toast.success(transWithParams('?item_X_added2order', [line.sku, line.qty], line.qty), toastSuccessOptions)
   // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [createOrUpdateLinesInOrder, live_order, transWithParams])

   const onReplaceDuplicate = useCallback(async () => {
      if (!duplicateLineDialog) return
      const { line } = duplicateLineDialog
      await createOrUpdateLinesInOrder(live_order.id, [line])
      toast.success(transWithParams('?item_X_replaced_in_order', [line.sku, line.qty]), toastSuccessOptions)
      setDuplicateLineDialog(null)
   // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [createOrUpdateLinesInOrder, duplicateLineDialog, live_order, transWithParams])

   const onCumulateDuplicate = useCallback(async () => {
      if (!duplicateLineDialog) return
      const { line, existingQty } = duplicateLineDialog
      const newQty = existingQty + line.qty
      await createOrUpdateLinesInOrder(live_order.id, [{ ...line, qty: newQty }])
      toast.success(transWithParams('?item_X_cumulated_in_order', [line.sku, newQty]), toastSuccessOptions)
      setDuplicateLineDialog(null)
   // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [createOrUpdateLinesInOrder, duplicateLineDialog, live_order, transWithParams])

   const onCancelDuplicate = useCallback(() => {
      setDuplicateLineDialog(null)
   }, [])

   const onSearch = useCallback(async () => {
      if (searchModeInOrder === search_type.in_catalog) {
         if (isRetailOrder(live_order) || isKOTOrKTM(live_order)) {
            // Retail : le SKU est le code modèle complet (pas de séparation model-color)
            clearAllRetailFilters()
            setCatalogRetailSearchText(searchText)
            navigate('/retail-catalog-detail', { replace: false })
         } else {
            const { model, color } = splitSKU(searchText)
            clearAllFilters()
            setCatalogSearchText(color ? model : searchText)
            navigate('/catalog-detail', { replace: false })
         }
      } else if (searchModeInOrder === search_type.manu_sku) {
         // Support multi-SKU : "E-0001*6,E-0012*15" → boucle + commit unique
         // Séparateur de quantité : X (ou x, normalisé via toUpperCase) ou *
         const rawInput = (searchText ?? '').toUpperCase()
         const tokens = rawInput.split(',').map(t => t.trim()).filter(Boolean)
         if (tokens.length === 0) return

         const orderIsRetail = isRetailOrder(live_order)
         const orderIsKOTOrKTM = isKOTOrKTM(live_order)
         // Les KOT/KTM contiennent forcément des SKU retail (budget de produits retail)
         const orderIsRetailLike = orderIsRetail || orderIsKOTOrKTM
         const toastErrorOptions = {
            position: 'top-right' as const,
            autoClose: 3500,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            theme: 'colored' as const,
         }
         // Tableau de validation/brouillon affiché : même logique d'ajout que « Ajouter ligne » (brouillon du tableau)
         if (isValidationMode) {
            if (validationTableRef.current?.addFromInput(rawInput)) setSearchText(null)
            return
         }

         // ─── MODE BULK : plusieurs SKU séparés par virgule ──────────────────
         if (tokens.length > 1) {
            // Pré-scan des quantités : toute qty invalide (NaN/≤0) → abort sans ajout
            const { lines: parsedLines, badTokens: badQtyTokens } = parseSkuQtyInput(rawInput)
            const parsedTokens = parsedLines.map(l => ({ rawSku: l.sku, qty: l.qty }))
            if (badQtyTokens.length > 0) {
               toast.error(trans('?Quantité invalide') + ' : ' + badQtyTokens.join(', '), toastErrorOptions)
               return
            }
            const linesToAdd: OrderLine[] = []
            const errors: string[] = []
            // Quotas non bloquants : on n'interdit plus l'ajout retail
            // (ni quand pas de KOT, ni quand SKU absent, ni en cas de dépassement).

            for (const { rawSku, qty } of parsedTokens) {
               const { model, color, size } = orderIsRetailLike
                  ? { model: rawSku, color: null as string | null, size: null as string | null }
                  : splitSKU(rawSku)
               const a_model = orderIsRetailLike ? getRetailModelById(model) : getModelById(model)

               if (!a_model) {
                  errors.push(rawSku)
                  continue
               }

               if (orderIsRetail) {
                  linesToAdd.push({ sku: model, qty })
               } else if (orderIsKOTOrKTM) {
                  linesToAdd.push({ sku: model, qty })
               } else {
                  // Bijoux : SKU complet requis en bulk (pas de picker)
                  if (!color || !size) {
                     errors.push(`${rawSku} (couleur/taille manquante)`)
                     continue
                  }
                  const fullSku = makeSKU(model, color, size)
                  const priceInfo = getCessPriceForModelBySKU(fullSku, region)
                  if (!priceInfo || !priceInfo.price) {
                     errors.push(`${fullSku} (pas de prix)`)
                     continue
                  }
                  linesToAdd.push({ sku: fullSku, qty, price: priceInfo.price })
               }
            }

            // Fusion doublons dans l'input + cumul avec l'existant
            const mergedInput = new Map<string, OrderLine>()
            for (const l of linesToAdd) {
               const ex = mergedInput.get(l.sku)
               mergedInput.set(l.sku, ex ? { ...ex, qty: ex.qty + l.qty } : l)
            }
            const existingMap = new Map(
               (live_order?.lines ?? []).filter(l => !l.comment).map(l => [l.sku, l.qty])
            )
            const finalLines = Array.from(mergedInput.values()).map(l => ({
               ...l,
               qty: l.qty + (existingMap.get(l.sku) ?? 0)
            }))

            if (finalLines.length > 0) {
               await createOrUpdateLinesInOrder(live_order.id, finalLines)
               setSearchText(null)
               toast.success(transWithParams('?X_lignes_ajoutees', [finalLines.length], finalLines.length), toastSuccessOptions)
            }
            if (errors.length > 0) {
               toast.error(trans('?Erreurs ajout SKU') + ' :\n' + errors.join('\n'), toastErrorOptions)
            }
            return
         }

         // ─── MODE SINGLE : 1 SKU (comportement existant) ────────────────────
         const parts = tokens[0].split(/[X*]/)

         if (parts.length > 0) {
            const { model, color, size } = orderIsRetailLike
               ? { model: parts[0], color: null as string | null, size: null as string | null }
               : splitSKU(parts[0])
            const a_model = orderIsRetailLike ? getRetailModelById(model) : getModelById(model)

            if (!a_model) {
               // Vérifier si le SKU existe dans l'autre famille pour donner un message explicite
               const a_model_other = orderIsRetailLike
                  ? getModelById(splitSKU(parts[0]).model)
                  : getRetailModelById(parts[0])
               let errorKey: string
               if (!a_model_other) {
                  errorKey = '?SKU inconnu'
               } else if (orderIsRetail) {
                  errorKey = '?SKU bijou dans commande retail'
               } else if (isKOTOrder(live_order)) {
                  errorKey = '?SKU bijou dans quota retail'
               } else if (isKTMOrder(live_order)) {
                  errorKey = '?SKU bijou dans modele quota retail'
               } else {
                  errorKey = '?SKU retail dans commande bijou'
               }
               toast.error(transWithParams(errorKey, [parts[0]]), toastErrorOptions)
            } else {
               const qtyExplicit = parts.length >= 2 && parts[1] !== ''
               let qty = 1
               if (qtyExplicit) {
                  const parsed = Number(parts[1])
                  if (!Number.isFinite(parsed) || parsed <= 0) {
                     toast.error(transWithParams('?Quantité invalide pour X', [parts[1]]), toastErrorOptions)
                     return
                  }
                  qty = parsed
               }

               if (orderIsRetail) {
                  // Ajout direct en retail : pas de variante à choisir.
                  // Le quota est non bloquant (cf. règle métier) — on ajoute toujours.
                  await commitLineWithDuplicateCheck({ sku: model, qty })
               } else if (orderIsKOTOrKTM && qtyExplicit) {
                  // KOT/KTM avec quantité explicite (SKUxN) : ajout direct sans picker
                  await commitLineWithDuplicateCheck({ sku: model, qty })
               } else if (!color && !size) {
                  setEditedLineNum(null)
                  setEditedSKU(parts[0])
                  setEditedModel(model)
                  setEditedColor(null)
                  setEditedSize(null)
                  setEditedQty(1) // Permet de ne pas avoir un bouton "Aucune commande sélectionnée"
                  setIsQtyPickerVisible(true)
                  // <QtyPicker model={editedModel} color={editedColor} size={editedSize} multi={editedAllVariations} qty={editedQty} onHide={hideQtyPicker} onUpdate={updateLines} />
               } else {
                  const sku = makeSKU(model, color, size) // Par sécurité on reconstruit un SKU propre
                  const price = getCessPriceForModelBySKU(sku, region)

                  if (price && price.price) {
                     await commitLineWithDuplicateCheck({ sku, qty, price: price.price })
                  } else {
                     toast.error(transWithParams('?Aucun prix pour ce SKU', [sku]), toastErrorOptions)
                  }
               }
            }
         }
      }
   }, [clearAllFilters, clearAllRetailFilters, commitLineWithDuplicateCheck, createOrUpdateLinesInOrder, getCessPriceForModelBySKU, getModelById, getRetailModelById, isKOTOrKTM, isKOTOrder, isKTMOrder, isRetailOrder, isValidationMode, live_order, makeSKU, navigate, region, searchModeInOrder, searchText, setCatalogRetailSearchText, setCatalogSearchText, splitSKU, trans, transWithParams])

   const onOrderChange = useCallback(
      (new_order) => {
         navigate(`/order-detail?id=${new_order}`, { replace: false })
      },
      [navigate]
   )

   // Remise ligne (ECF uniquement, rôle admin/N1/N2 pour CE customer, status new/wait_n2/wait_n1)
   const canEditDiscount = useCallback(() => {
      if (live_order?.type !== type_order.retail_externe) return false
      if (isReadOnly) return false
      if (!roleForOrder.effectiveRole) return false
      const s = live_order?.status
      return s === order_status.new || s === order_status.new_mgr || s === order_status.wait_n2 || s === order_status.wait_n1
   }, [isReadOnly, live_order, order_status, roleForOrder, type_order.retail_externe])

   useEffect(() => {
      setDropdownMenuGlobal(
         <DropdownMenu noscrollbars right={-20} top={30} onSelect={onSelectGlobal}>
            {/* « Sélectionner » seulement si la commande est réellement modifiable : on se base sur le
                STATUT (le flag local readonly n'est pas fiable — une wait_n1 « vue » peut arriver readonly=false)
                et non sur isReadOnly seul. Une commande soumise/verrouillée n'est jamais sélectionnable. */}
            {!isValidationMode && !isOrderSubmittedOrLocked(live_order?.status) && canWriteKOT(live_order, roleForOrder) && (
               <li disabled={curOrder === live_order?.id} id={menu_items.setActive}>
                  <FontAwesomeIcon icon={faBadgeCheck} />
                  {trans('?Sélectionner')}
               </li>
            )}
            <li id={menu_items.sendPdf}>
               <FontAwesomeIcon icon={faFilePdf} />
               {trans('?Envoyer en PDF à...')}
            </li>
            {/* Dupliquer un KOT = créer un nouveau quota → réservé admin/N1 (canWriteKOT), comme la création. */}
            {canWriteKOT(live_order, roleForOrder) && (
               <li id={menu_items.doClone}>
                  <FontAwesomeIcon icon={faClone} />
                  {trans('?Dupliquer')}
               </li>
            )}
            {isKTMOrder(live_order) && canCreateKTM() && (
               <li id={menu_items.doDeployKTM}>
                  <FontAwesomeIcon icon={faObjectGroupProLight} />
                  {trans('?Déployer vers clients')}
               </li>
            )}
            {isKTMOrder(live_order) && canCreateKTM() && (
               <li id={menu_items.doUnDeployKTM}>
                  <FontAwesomeIcon icon={faCircleXmark} />
                  {trans('?Supprimer le déploiement')}
               </li>
            )}
            {canEditDiscount() && (
               <li id={menu_items.doBulkDiscount}>
                  <FontAwesomeIcon icon={faPercentLight} />
                  {trans('?Remise globale')}
               </li>
            )}
            {isKOTOrKTM(live_order) && (
               <>
                  <li id={menu_items.exportCSV}>
                     <FontAwesomeIcon icon={faFileCsv} />
                     {trans('?Exporter CSV')}
                  </li>
                  <li id={menu_items.exportExcel}>
                     <FontAwesomeIcon icon={faFileExcel} />
                     {trans('?Exporter Excel')}
                  </li>
                  {!isReadOnly && (
                     <li id={menu_items.importFile}>
                        <FontAwesomeIcon icon={faFileImport} />
                        {trans('?Importer CSV/Excel')}
                     </li>
                  )}
               </>
            )}
            {!isReadOnly && canWriteKOT(live_order, roleForOrder) && (
               <>
                  <li id={menu_items.doDelete}>
                     <FontAwesomeIcon icon={faTrashCan} />
                     {trans('?Supprimer')}
                  </li>
                  {!isKOTOrKTM(live_order) && (
                     <li id={menu_items.doSign} disabled={isProspect}>
                        <FontAwesomeIcon icon={faSignature} />
                        {trans('?Signature client')}
                     </li>
                  )}
               </>
            )}
            {/* ───── Bloc workflow Retail manager (fin de menu, au-dessus de Sauvegarde/Restaurer) ─────
                Ordre imposé : Soumission / Validation finale EN PREMIER, puis l'action de RETOUR AU
                CLIENT juste en dessous :
                  - new_mgr         → "Envoyer au client" (doSendToClient, new_mgr → new)
                  - wait_n2/wait_n1 → "Renvoyer au client" (doUnlock, returnRetailToClient → new)
                La soumission/validation d'un brouillon manager (new_mgr) est gâtée par la complétude
                (contremarque + adresse) via isOrderComplete. */}
            {_isRetail && (effectiveRetailRole === 'admin' || effectiveRetailRole === 'N1' || effectiveRetailRole === 'N2') && ((!isValidationMode && _retailStatus === order_status.new) || _retailStatus === order_status.new_mgr || _retailStatus === order_status.wait_n2 || _retailStatus === order_status.wait_n1) && (
               <hr style={{ border: 'none', borderTop: '1px solid #ddd', margin: '6px 0' }} />
            )}
            {!isValidationMode && _isRetail && (effectiveRetailRole === 'admin' || effectiveRetailRole === 'N1' || effectiveRetailRole === 'N2') && _retailStatus === order_status.new && (
               <li id={menu_items.doSync}>
                  <FontAwesomeIcon icon={faArrowRight} />
                  {trans('?Soumettre')}
               </li>
            )}
            {/* Soumission/validation N2 (sync M3 ou soumission au valideur final). Affiché AUSSI en
                mode validation. Gâté par la complétude pour un brouillon manager (new_mgr). */}
            {_isRetail && effectiveRetailRole === 'N2' && (_retailStatus === order_status.wait_n2 || _retailStatus === order_status.new_mgr) && (
               <li id={menu_items.doValidateN2} disabled={!isOrderComplete(live_order)}>
                  <FontAwesomeIcon icon={faArrowRight} />
                  {trans('?Soumettre')}
               </li>
            )}
            {_isRetail && (effectiveRetailRole === 'admin' || effectiveRetailRole === 'N1') && (_retailStatus === order_status.wait_n2 || _retailStatus === order_status.wait_n1 || _retailStatus === order_status.new_mgr) && (
               <li id={menu_items.doValidateN1} disabled={!isOrderComplete(live_order)}>
                  <FontAwesomeIcon icon={faLock} />
                  {trans('?Validation finale')}
               </li>
            )}
            {/* Retour au client, JUSTE SOUS la soumission/validation.
                new_mgr → 'new' via send-to-client (pose les perms du user-client). Icône identique
                à celle des wait_n* ; libellé « Envoyer au client » (le client ne l'a jamais eue). */}
            {_isRetail && _retailStatus === order_status.new_mgr && (effectiveRetailRole === 'admin' || effectiveRetailRole === 'N1' || effectiveRetailRole === 'N2') && (
               <li id={menu_items.doSendToClient}>
                  <FontAwesomeIcon icon={faLockOpen} />
                  {trans('?Envoyer au client')}
               </li>
            )}
            {_isRetail && (effectiveRetailRole === 'admin' || effectiveRetailRole === 'N1' || effectiveRetailRole === 'N2') && (_retailStatus === order_status.wait_n2 || _retailStatus === order_status.wait_n1) && (
               <li id={menu_items.doUnlock}>
                  <FontAwesomeIcon icon={faLockOpen} />
                  {trans('?Renvoyer au client')}
               </li>
            )}
            {/* Soumettre (Retail user-client) / Synchroniser (classique) : placé en fin de menu, juste
                au-dessus de Sauvegarde/Restaurer (le <hr> suivant fait la séparation). Masqué KOT/KTM
                et managers Retail (eux ont le bloc workflow ci-dessus). */}
            {!isReadOnly && !isKOTOrKTM(live_order) && !roleForOrder.effectiveRole && (_isRetail ? retailRole === 'client' : true) && (
               <>
                  <hr style={{ border: 'none', borderTop: '1px solid #ddd', margin: '6px 0' }} />
                  <li id={menu_items.doSync} disabled={isProspect || live_order?.status !== order_status.new || (live_order && !canSyncOrder(live_order))}>
                     <FontAwesomeIcon icon={_isRetail ? faArrowRight : faCloudArrowUp} />
                     {trans(_isRetail ? '?Soumettre' : '?Synchroniser')}
                  </li>
               </>
            )}
            <hr style={{ border: 'none', borderTop: '1px solid #ddd', margin: '6px 0' }} />
            <li id={menu_items.exportJSON}>
               <FontAwesomeIcon icon={faFloppyDisk} />
               {trans('?Sauvegarde locale')}
            </li>
            {!isReadOnly && (
               <li id={menu_items.importJSON}>
                  <FontAwesomeIcon icon={faRotateLeft} />
                  {trans('?Restaurer une sauvegarde')}
               </li>
            )}
         </DropdownMenu>
      )
      setDropdownMenuLine(
         <DropdownMenu noscrollbars right={-20} top={20} onSelect={onSelectLine}>
            <li id={line_menu_items.doEdit}>
               <FontAwesomeIcon icon={faPenToSquare} />
               {trans('?Modifier')}
            </li>
            <li id={line_menu_items.doDelete}>
               <FontAwesomeIcon icon={faTrashCan} />
               {trans('?Supprimer')}
            </li>
            <li id={line_menu_items.doViewInCatalog}>
               <FontAwesomeIcon icon={isRetailOnly ? faBoxProLight : faGemProLight} />
               {trans('?Voir dans le catalogue')}
            </li>
         </DropdownMenu>
      )
      setSearchBar(
         <Searchbar
            text={searchText}
            onSearch={onSearch}
            lefticon={searchModeInOrder === search_type.manu_sku && faPen}
            placeholder={trans(searchModeInOrder === search_type.manu_sku ? '?Ajout de ligne par SKU' : searchModeInOrder === search_type.in_catalog ? '?Recherche dans le catalogue' : '?Recherche dans cette commande')}
            onChange={(text) => setSearchText(text)}
            onOrderChange={onOrderChange}
         >
            <div className={styles_Searchbar.search_tools}>
               <button
                  className={searchModeInOrder === search_type.in_catalog ? styles_Searchbar.red : ''}
                  onClick={() => {
                     setSearchModeInOrder(search_type.in_catalog)
                  }}
               >
                  <FontAwesomeIcon icon={(isRetailOrder(live_order) || isKOTOrKTM(live_order)) ? faBox : faGem} />
               </button>
               <button
                  className={searchModeInOrder === search_type.in_order ? styles_Searchbar.red : ''}
                  onClick={() => {
                     setSearchModeInOrder(search_type.in_order)
                  }}
               >
                  <FontAwesomeIcon icon={faFileLinesSolid} />
               </button>
               {!isReadOnly && live_order && (curOrder === live_order?.id || isValidationMode) && (
                  <button
                     className={searchModeInOrder === search_type.manu_sku ? styles_Searchbar.red : ''}
                     onClick={() => {
                        setSearchModeInOrder(search_type.manu_sku)
                     }}
                  >
                     <FontAwesomeIcon icon={faPenField} />
                  </button>
               )}
            </div>
         </Searchbar>
      )
   }, [_isRetail, _retailStatus, canCreateKTM, canEditDiscount, canSyncOrder, isOrderComplete, canWriteKOT, curOrder, effectiveRetailRole, isKOTOrKTM, isKTMOrder, isOrderSubmittedOrLocked, isProspect, isReadOnly, isRetailOnly, isRetailOrder, isValidationMode, live_order, n2IsLastStep, onOrderChange, onSearch, onSelectGlobal, onSelectLine, order_status, retailRole, roleForOrder, searchModeInOrder, searchText, setSearchModeInOrder, trans])

   const onShowMenu = useCallback(
      (evt, id) => {
         evt.stopPropagation()
         if (showDropdownMenuOnLineNum === id) {
            setShowDropdownMenuOnLineNum(null)
         } else {
            setShowDropdownMenuOnLineNum(id)
            setLastSelectedLineNum(id)
         }
         setShowDropdownMenuGlobal(false)
      },
      [showDropdownMenuOnLineNum]
   )

   function makeActive() {
      // Garde : un KOT n'est sélectionnable que par admin/N1 (cf. canWriteKOT).
      if (!canWriteKOT(live_order, roleForOrder)) return
      setOrderIdAsCurrent(live_order?.id)
   }

   // useEffect(()=>{
   //    if (searchModeInOrder === )
   // },[searchModeInOrder])

   useEffect(() => {
      console.log('>>>', searchText)
      if (searchModeInOrder === search_type.in_order && searchText?.trim().length > 0) {
         const text = searchText?.trim().toUpperCase()
         const arr = live_order?.lines.filter((a_line) => {
            if (isKOTOrKTM(live_order) || isRetailOrder(live_order)) {
               const model = getRetailModelById(a_line.sku)
               return a_line.sku.toUpperCase().includes(text) || (model?.label ?? '').toUpperCase().includes(text)
            }
            const [model_id, ,] = a_line.sku.split('-')
            const model = getModelById(model_id)
            return model && (a_line.sku.includes(text) || model.label.toUpperCase().includes(text))
         })
         setFilteredLines(arr)
      } else {
         setFilteredLines(live_order?.lines)
      }
   }, [getModelById, getRetailModelById, isKOTOrKTM, isRetailOrder, live_order, searchModeInOrder, searchText])

   const closeAllDropDowns = useCallback(() => {
      let ret = false

      if (isMenuOrderTypeVisible) {
         setIsMenuOrderTypeVisible(false)
         ret = true
      }
      if (showDropdownMenuGlobal) {
         setShowDropdownMenuGlobal(false)
         ret = true
      }
      if (showDropdownMenuOnLineNum) {
         setShowDropdownMenuOnLineNum(null)
         ret = true
      }
      return ret
   }, [isMenuOrderTypeVisible, showDropdownMenuGlobal, showDropdownMenuOnLineNum])

   const onEditLineComment = useCallback(
      (num_line) => {
         if (!closeAllDropDowns()) {
            setEditedLineNum(num_line)
            setEditedLineComment(filteredLines[num_line - 1].comment)
            setIsLineCommentEditorVisible(true)
         }
      },
      [closeAllDropDowns, filteredLines]
   )

   function onCancelEditLineComment() {
      setIsLineCommentEditorVisible(false)
      setEditedLineComment(null)
      setEditedLineNum(null)
   }

   function onValidateEditLineComment(text) {
      const lines = live_order.lines.reduce((prev, cur, index) => {
         if (index === editedLineNum - 1) {
            return [...prev, { ...cur, comment: text }]
         } else {
            return [...prev, { ...cur }]
         }
      }, [])

      setIsLineCommentEditorVisible(false)
      updateOrder(live_order.id, {
         lines: [...lines]
      })
      setEditedLineComment(null)
      setEditedLineNum(null)
   }

   const onEditLineDiscount = useCallback((num_line: number) => {
      if (!canEditDiscount()) return
      if (closeAllDropDowns()) return
      setEditedLineNum(num_line)
      setEditedLineDiscount(filteredLines?.[num_line - 1]?.discount ?? 0)
      setIsLineDiscountEditorVisible(true)
   }, [canEditDiscount, closeAllDropDowns, filteredLines])

   function onCancelEditLineDiscount() {
      setIsLineDiscountEditorVisible(false)
      setEditedLineDiscount(null)
      setEditedLineNum(null)
   }

   function onCancelBulkDiscount() {
      setIsBulkDiscountEditorVisible(false)
   }

   const onJSONImportFileChange = useCallback(async (e: React.ChangeEvent<HTMLInputElement>) => {
      const file = e.target.files?.[0]
      if (jsonImportRef.current) jsonImportRef.current.value = ''
      if (!file) return
      try {
         const text = await file.text()
         const data = JSON.parse(text) as Order
         if (!data.id || !data.customer_id || !Array.isArray(data.lines)) {
            toast.error(trans('?Fichier JSON invalide'), { position: 'top-right', autoClose: 3000, theme: 'colored' })
            return
         }
         if (data.type !== live_order?.type) {
            toast.error(transWithParams('?Type incompatible : %1 ≠ %2', [data.type ?? '?', live_order?.type ?? '?']), { position: 'top-right', autoClose: 4000, theme: 'colored' })
            return
         }
         if (data.customer_id !== live_order?.customer_id) {
            toast.error(transWithParams('?Client incompatible : %1 ≠ %2', [data.customer_id ?? '?', live_order?.customer_id ?? '?']), { position: 'top-right', autoClose: 4000, theme: 'colored' })
            return
         }
         setImportJSONOrder(data)
      } catch {
         toast.error(trans('?Erreur lors de la lecture du fichier'), { position: 'top-right', autoClose: 3000, theme: 'colored' })
      }
   }, [live_order?.customer_id, live_order?.type, trans, transWithParams])

   const onConfirmImportJSON = useCallback(async () => {
      if (!importJSONOrder || !live_order?.id) return
      // On écrase toujours la commande courante avec le contenu du fichier (l'ID du fichier est ignoré)
      await updateOrder(live_order.id, {
         lines: live_order.type === TRI_TYPE ? splitLinesToUnit(importJSONOrder.lines) : importJSONOrder.lines,
         mark: importJSONOrder.mark,
         comment: importJSONOrder.comment,
         signature: importJSONOrder.signature,
         addresses: importJSONOrder.addresses,
         delivery: importJSONOrder.delivery,
      })
      // lignes telles que persistées (updateOrder peut les retoucher : remises retail)
      setPendingRestoreLines((await getOrderById(live_order.id)).lines ?? [])
      toast.success(trans('?Commande restaurée'), { position: 'top-right', autoClose: 2500, theme: 'colored' })
      setImportJSONOrder(null)
   }, [importJSONOrder, live_order, updateOrder, getOrderById, trans])

   useEffect(() => {
      const pending = pendingRestoreLines
      if (!pending || !live_order) return
      if (JSON.stringify(live_order.lines ?? []) !== JSON.stringify(pending)) return
      setPendingRestoreLines(null)
      setValidationTableKey(k => k + 1)
   }, [live_order, pendingRestoreLines])

   function onValidateBulkDiscount(val: number) {
      const lines = live_order.lines.map(line => {
         const { discount: _drop, ...rest } = line
         return val > 0 ? { ...rest, discount: val } : { ...rest }
      })
      updateOrder(live_order.id, { lines })
      setIsBulkDiscountEditorVisible(false)
   }

   function onValidateEditLineDiscount(val: number) {
      const lines = live_order.lines.reduce((prev, cur, index) => {
         if (index === editedLineNum - 1) {
            // 0 ou NaN → on retire la remise (champ absent)
            const { discount: _drop, ...rest } = cur
            if (val > 0) {
               return [...prev, { ...rest, discount: val }]
            }
            return [...prev, { ...rest }]
         }
         return [...prev, { ...cur }]
      }, [] as OrderLine[])

      setIsLineDiscountEditorVisible(false)
      updateOrder(live_order.id, { lines: [...lines] })
      setEditedLineDiscount(null)
      setEditedLineNum(null)
   }

   useEffect(() => {
      let num = 0

      // console.log('+++', 'ICI');
      const arr = filteredLines?.map((a_line) => {
         num++
         // console.log(model_id, model);
         const cur_num = num // Pour avoir une variable unique pour chaque ligne plus bas (event menu)
         // const cur_line_comment = a_line.comment
         if (isRetailOrder(live_order) || isKOTOrKTM(live_order)) {
            const model = getRetailModelById(a_line.sku)
            // « Quota restant » = restant HORS cette commande (budget − consommé des AUTRES commandes ;
            // la commande courante est déjà exclue via excludeOrderId dans getRetailQuota). Affichage
            // centralisé via formatSkuRemaining : valeur, ou tiret cadratin « — » si SKU hors KOT actif.
            return (
               <tr key={`line_${num}`}>
                  <td className={styles.num_line}>{num}</td>
                  <td className={styles.modele_id}>{a_line.sku}</td>
                  <td className={styles.model_label}>{model?.label ?? ''}</td>
                  {isRetailOrder(live_order) && (
                     <td className={styles.col_stock} style={{ textAlign: 'left' }}>
                        {(() => {
                           const stock = orderLineStocks.get(a_line.sku) ?? null
                           if (stock === null) return <span className={styles.stock_loading}>…</span>
                           const entries = Object.entries(stock.per_depot)
                           if (entries.length === 0) return '—'
                           const isMulti = entries.length > 1
                           const custDepot = customer?.depot_retail ?? null
                           return (
                              <span className={stock.available ? styles.stock_ok : styles.stock_ko}>
                                 {entries.map(([code, qty], i) => {
                                    const qtyDisplay = typeof qty === 'number' ? formatNumber(qty, 0) : String(qty)
                                    const codeLabel = code.startsWith('S') ? code.substring(1) : code
                                    const isCust = isMulti && code === custDepot
                                    const labelEl = <>{codeLabel}:&nbsp;{qtyDisplay}</>
                                    return (
                                       <span key={code}>
                                          {i > 0 && ', '}
                                          {isCust ? <span className={styles.stock_customer_depot}>{labelEl}</span> : labelEl}
                                       </span>
                                    )
                                 })}
                              </span>
                           )
                        })()}
                     </td>
                  )}
                  <td className={styles.qty} style={{ textAlign: 'right' }}>{a_line.qty}</td>
                  {(isKOTOrKTM(live_order) || hasActiveKOT) && !isKOTOrder(live_order) && (
                     <td className={styles.remain_qty} style={{ textAlign: 'right' }}>
                        {formatSkuRemaining(retailQuotas, a_line.sku)}
                     </td>
                  )}
                  {live_order?.type === type_order.retail_externe && (hasDisplayableDiscount || canEditDiscount()) && (
                     <td
                        className={styles.discount}
                        style={{ textAlign: 'right', cursor: canEditDiscount() ? 'pointer' : 'default' }}
                        onClick={() => { if (canEditDiscount()) onEditLineDiscount(cur_num) }}
                     >
                        {a_line.discount ? `${a_line.discount}%` : ''}
                     </td>
                  )}
                  <td className={styles.price}>{formatRetailPrice(model, formatCESPrice(a_line.price ?? getMinMaxCessPriceForModel(a_line.sku, region)?.min ?? 0, currency), customer, 'order_line')}</td>
                  {!isReadOnly && isSelected && (
                     <td className={styles.actions}>
                        <span onClick={(evt) => onShowMenu(evt, cur_num)}>
                           {trans('?Détail', true)}
                           <FontAwesomeIcon icon={faAngleRight} />
                           {showDropdownMenuOnLineNum === num ? dropdownMenuLine : ''}
                        </span>
                     </td>
                  )}
               </tr>
            )
         } else {
            const [model_id, color, size] = a_line.sku.split('-')
            const model = getModelById(model_id)

            return (
               <tr key={`line_${num}`}>
                  <td className={styles.num_line}>{num}</td>
                  <td className={styles.modele_id}>{model_id}</td>
                  <td className={styles.model_color}>
                     <div>
                        <span>{color}</span>
                     </div>
                  </td>
                  <td className={styles.model_size}>
                     <div>
                        <span>{size}</span>
                     </div>
                  </td>
                  <td className={styles.model_label}>{model?.label ?? <FontAwesomeIcon icon={faLinkHorizontalSlash} />}</td>
                  <td
                     className={styles.comment}
                     onClick={() => {
                        if (!isReadOnly) onEditLineComment(cur_num)
                     }}
                  >
                     <div>{a_line.comment}</div>
                  </td>
                  <td className={styles.qty}>{a_line.qty}</td>
                  <td className={styles.remain_qty}>{typeof a_line.remain_qty === 'number' ? a_line.remain_qty : a_line.qty}</td>
                  <td className={styles.price}>{formatCESPrice(a_line.price, currency)}</td>
                  {!isReadOnly && isSelected && (
                     <td className={styles.actions}>
                        <span onClick={(evt) => onShowMenu(evt, cur_num)}>
                           {/* <FontAwesomeIcon icon={faGear} /> */}
                           {trans('?Détail', true)}
                           <FontAwesomeIcon icon={faAngleRight} />
                           {showDropdownMenuOnLineNum === num ? dropdownMenuLine : ''}
                        </span>
                     </td>
                  )}
               </tr>
            )
         }
      })
      setLines(arr)
   }, [
      canEditDiscount,
      currency,
      dropdownMenuLine,
      filteredLines,
      formatCESPrice,
      formatRetailPrice,
      getMinMaxCessPriceForModel,
      getModelById,
      isKOTOrKTM,
      isKOTOrder,
      isReadOnly,
      onEditLineComment,
      onEditLineDiscount,
      onShowMenu,
      region,
      showDropdownMenuOnLineNum,
      trans,
      isSelected,
      getRetailModelById,
      formatLength,
      isRetailOrder,
      live_order,
      formatRetailWeightWithNC,
      retailQuotas,
      formatSkuRemaining,
      hasActiveKOT,
      hasDisplayableDiscount,
      type_order.retail_externe,
      customer,
      orderLineStocks,
      formatNumber,
   ])

   const onSelectOrderType = useCallback(
      (id) => {
         // console.log('ID>>', id, showDropdownMenuOnCustomerId);
         setIsMenuOrderTypeVisible(false)
         if (!canConvertOrderType(live_order?.type, id)) return
         // Vers TRI : chaque ligne de qté N est éclatée en N lignes de qté 1
         const lines = convertLinesForType(live_order?.type, id, live_order?.lines ?? [])
         const lines_attr = lines !== live_order?.lines ? { lines } : {}
         if (live_order?.type === type_order.confie) {
            updateOrder(live_order.id, {
               type: id,
               addresses: { ...live_order.addresses, ecrins: null },
               ...lines_attr
            })
         } else {
            updateOrder(live_order.id, {
               type: id,
               ...lines_attr
            })
         }
      },
      [live_order, updateOrder, type_order]
   )

   useEffect(() => {
      if (isRetailOrder(live_order)) {
         // Le type autorisé pour ce client (ECR ou ECF) est déterminé par la
         // grille métier (DocRetail/GRILLE_ECR_ECF.txt → getRetailOrderType).
         // Un client donné a UN seul type possible : l'autre est désactivé pour tous,
         // y compris admin/N1/N2 (sinon on injecte de la donnée incohérente côté M3).
         const allowedOrderType = getRetailOrderType(customer)
         const allowedRetailType = allowedOrderType === 'ECR' ? type_order.retail_interne
            : allowedOrderType === 'ECF' ? type_order.retail_externe
            : null
         setDropdownMenuOrderType(
            <DropdownMenu noscrollbars left={-5} top={-5} onSelect={onSelectOrderType}>
               <li className={live_order?.type === type_order.retail_interne ? styles_DropdownMenu.selected : ''} id={type_order.retail_interne} disabled={allowedRetailType !== type_order.retail_interne}>
                  <FontAwesomeIcon icon={faBoxProLight} />
                  {trans('?Retail interne')}
               </li>
               <li className={live_order?.type === type_order.retail_externe ? styles_DropdownMenu.selected : ''} id={type_order.retail_externe} disabled={allowedRetailType !== type_order.retail_externe}>
                  <FontAwesomeIcon icon={faBoxProLight} />
                  {trans('?Retail externe')}
               </li>
            </DropdownMenu>
         )
      } else {
         setDropdownMenuOrderType(
            <DropdownMenu noscrollbars left={-5} top={-5} onSelect={onSelectOrderType}>
               <li className={live_order?.type === type_order.commande ? styles_DropdownMenu.selected : ''} id={type_order.commande} disabled={isProspect}>
                  <FontAwesomeIcon icon={faGemProLight} />
                  {trans('?Commande')}
               </li>
               <li className={live_order?.type === type_order.implant ? styles_DropdownMenu.selected : ''} id={type_order.implant} disabled={isProspect}>
                  <FontAwesomeIcon icon={faShelvesProLight} />
                  {trans('?Implantation')}
               </li>
               <li className={live_order?.type === type_order.confie ? styles_DropdownMenu.selected : ''} id={type_order.confie} disabled={isProspect}>
                  <FontAwesomeIcon icon={faHandHoldingBoxProLight} />
                  {trans('?Confié')}
               </li>
               <li className={live_order?.type === type_order.triangulaire ? styles_DropdownMenu.selected : ''} id={type_order.triangulaire} disabled={isProspect || !canConvertOrderType(live_order?.type, TRI_TYPE)}>
                  <FontAwesomeIcon icon={faRecycleProLight} />
                  {trans('?Triangulaire')}
               </li>
               <li className={live_order?.type === type_order.devis ? styles_DropdownMenu.selected : ''} id={type_order.devis}>
                  <FontAwesomeIcon icon={faFilePenProLight} />
                  {trans('?Devis')}
               </li>
            </DropdownMenu>
         )
      }
   }, [customer, getRetailOrderType, isProspect, isRetailOrder, live_order, onSelectOrderType, trans, type_order])

   function doNothing(evt) {
      // console.log('doNothing')
      evt.stopPropagation()
      setShowDropdownMenuGlobal(false)
      setIsAddressPickerVisible(false)
      setIsMenuOrderTypeVisible(false)
      setShowDropdownMenuOnLineNum(null)
   }

   function toogleShowDropdownMenuGlobal(evt) {
      evt.stopPropagation()
      setShowDropdownMenuGlobal(!showDropdownMenuGlobal)
      setIsAddressPickerVisible(false)
      setIsMenuOrderTypeVisible(false)
      setShowDropdownMenuOnLineNum(null)
   }

   function toggleShowDropdownMenuOrderType(evt) {
      evt.stopPropagation()
      setIsAddressPickerVisible(false)
      setShowDropdownMenuGlobal(false)
      setIsMenuOrderTypeVisible(!isMenuOrderTypeVisible)
   }

   function toggleShowAddressPicker(evt) {
      evt.stopPropagation()
      setIsAddressPickerVisible(!isAddressPickerVisible)
      setShowDropdownMenuGlobal(false)
      setIsMenuOrderTypeVisible(false)
   }

   function hideQtyPicker() {
      setIsQtyPickerVisible(false)
   }

   async function onConfirmOK() {
      setIsConfirmVisible(false)
      if (confirmType === confirm_type.conf_delete_line) {
         console.log(editedModel, editedColor, editedSize)
         deleteSingleLineInOrder(live_order.id, editedLineNum)
      } else if (confirmType === confirm_type.conf_delete_order) {
         await deleteOrder(live_order.id)
         navigate('/orders', { replace: false })
      }
      setConfirmType(null)
   }

   function onConfirmCancel() {
      setConfirmType(null)
      setIsConfirmVisible(false)
   }

   // Si multi === false, on remplace la ligne éditée, ça permet de changer éventuellement couleur et taille
   // Si multi === true, ça fonctionne aussi mais automatiquement
   // Si is_retail === true,
   function _updateLines(model, multi, variations, is_retail) {
      console.log('::VARIATIONS', model, multi ? 'MULTI' : 'MONO', variations)
      if (multi) {
         if (!is_retail) {
            // En multi on envoie l'intégralité en CreateOrUpdate. Les anciennes valeurs modifiées ou absentes seront modifiées/supprimées auto
            const guardEntries: SkuVariantGuardEntry[] = []
            const lines = variations.flatMap((an_item) => {
               const { color, size, qty } = an_item
               const decision = sanitizeSkuVariant(model, color, size, region)

               if (decision.dropped.length > 0 || !decision.ok) {
                  guardEntries.push({ requestedSku: makeSKU(model, color, size), keptSku: makeSKU(model, decision.color, decision.size), decision })
               }
               if (!decision.ok) {
                  return []
               }

               const price = getCessPriceForModelColorSize(model, decision.color, decision.size, region)?.price ?? 0

               return [
                  {
                     sku: makeSKU(model, decision.color, decision.size),
                     qty: qty,
                     price: price
                  }
               ]
            })

            createOrUpdateLinesInOrder(live_order.id, lines)

            if (guardEntries.length > 0) {
               reportSkuVariantGuard(guardEntries, trans, transWithParams)
            }
         } else {
            console.error(`Pas de multi ligne en Retail !!!`)
         }
      } else {
         // En mono :
         // - Si la couleur ou la taille a changé, on envoie une qté = 0 pour supprimer cette ligne
         // - Et on envoie une ligne avec la nouvelle quantité pour la couleur+taille choisie dans le Picker.
         //   Si la couleur et la taille n'ont pas changé, ça fera donc un remplacement.
         // Mode mono, variations est forcément 1 seul objet
         const single = variations[0]

         if (is_retail) {
            // En Retail, on update juste la qté
            const { qty } = single

            createOrUpdateLinesInOrder(
               live_order.id,
               [
                  {
                     sku: model,
                     qty: qty
                  }
               ],
               lastSelectedLineNum
            )
         } else {
            const { color, size, qty } = single
            console.log(`Single: ${qty} X ${color}-${size}`)
            console.log(`Edited: ${editedColor}-${editedSize}`)

            const decision = sanitizeSkuVariant(model, color, size, region)

            if (decision.dropped.length > 0 || !decision.ok) {
               reportSkuVariantGuard([{ requestedSku: makeSKU(model, color, size), keptSku: makeSKU(model, decision.color, decision.size), decision }], trans, transWithParams)
            }

            if (!decision.ok) {
               // Ligne rejetée : aucune écriture (ni création, ni suppression de l'ancienne ligne)
               return
            }

            if (live_order?.type === TRI_TYPE) {
               // Triangulaire : la ligne est ciblée par sa position (jamais par SKU), reste en qté 1,
               // et qté N > 1 ajoute N-1 lignes ; qté 0 supprime la ligne.
               const changed = decision.color !== editedColor || decision.size !== editedSize
               const price = changed ? (getCessPriceForModelColorSize(model, decision.color, decision.size, region)?.price ?? 0) : undefined
               createOrUpdateLinesInOrder(
                  live_order.id,
                  [{ sku: makeSKU(model, decision.color, decision.size), qty: qty, ...(price !== undefined ? { price } : {}) }],
                  lastSelectedLineNum
               )
            } else if (decision.color === editedColor && decision.size === editedSize) {
               // Juste modif qté (comparaison après élagage, cf. messika-pwa#7)
               // console.log('Remplacement');
               createOrUpdateLinesInOrder(
                  live_order.id,
                  [
                     {
                        sku: makeSKU(model, decision.color, decision.size),
                        qty: qty
                     }
                  ],
                  lastSelectedLineNum
               )
            } else {
               // Changement taille ou couleur + qté
               // console.log('Autre color/size');
               const price = getCessPriceForModelColorSize(model, decision.color, decision.size, region)?.price ?? 0

               createOrUpdateLinesInOrder(live_order.id, [
                  {
                     // On supprime l'ancien — clé jamais assainie : doit matcher la ligne existante telle qu'en base,
                     // y compris si elle est polluée (sinon elle deviendrait indéletable)
                     sku: makeSKU(model, editedColor, editedSize),
                     qty: 0
                  },
                  {
                     // On crée un nv
                     sku: makeSKU(model, decision.color, decision.size),
                     qty: qty,
                     price: price
                  }
               ])
            }
         }
      }
   }

   function updateLines(model, multi, variations) {
      return _updateLines(model, multi, variations, false)
   }

   function updateRetailLines(model, multi, variations) {
      return _updateLines(model, multi, variations, true)
   }

   function handleOrderDateSelect(val) {
      console.log(moment(val).format('YYYY-MM-DD'))
      updateOrder(live_order.id, {
         date: moment(val).format('YYYY-MM-DD')
      })
   }

   function handleDeliveryDateSelect(val) {
      console.log(moment(val).format('YYYY-MM-DD'))
      updateOrder(live_order.id, {
         delivery: moment(val).format('YYYY-MM-DD')
      })
   }

   useEffect(() => {
      setKeepSearchBarAccessible(false)
      setIsDarkLayerVisible(isQtyPickerVisible || isCommentEditorVisible || isAddressPickerVisible || isLineCommentEditorVisible || isContremarqueEditorVisible || isMailAddressPickerVisible || isQuotaCloneEditorVisible || isLineDiscountEditorVisible || isBulkDiscountEditorVisible || showKtmDeployer || !!unDeployKtm || !!deployProgress || !!importJSONOrder)
   }, [isCommentEditorVisible, isLineCommentEditorVisible, isContremarqueEditorVisible, isQtyPickerVisible, setIsDarkLayerVisible, setKeepSearchBarAccessible, isAddressPickerVisible, isMailAddressPickerVisible, isQuotaCloneEditorVisible, isLineDiscountEditorVisible, isBulkDiscountEditorVisible, showKtmDeployer, unDeployKtm, deployProgress, importJSONOrder])

   useEffect(() => {
      if (!isDarkLayerVisible) {
         setIsQtyPickerVisible(false)
      }
   }, [isDarkLayerVisible])

   const onEditContremarque = useCallback(() => {
      if (!closeAllDropDowns()) {
         setIsContremarqueEditorVisible(true)
      }
   }, [closeAllDropDowns])

   function onCancelEditContremarque() {
      setIsContremarqueEditorVisible(false)
   }

   const onViewExistingQuota = useCallback((mark: string) => {
      const isKOT = isKOTOrder(live_order)
      const targetType = isKOT ? type_order.retail_quota : type_order.ktm_quota
      const customerId = live_order?.customer_id
      const found = (live_unsync_orders ?? []).find(o => {
         if (o.mark !== mark || o.type !== targetType || o.id === live_order?.id) return false
         if (isKOT) return o.customer_id === customerId
         return true
      })
      if (!found?.id) return
      setIsContremarqueEditorVisible(false)
      setIsQuotaCloneEditorVisible(false)
      navigate(`/order-detail?id=${found.id}`, { replace: false })
   }, [isKOTOrder, live_order, live_unsync_orders, navigate, type_order.ktm_quota, type_order.retail_quota])

   /**
    * Déploie le KTM en édition vers la liste de clients cochés.
    * - KTM non vide : crée un KOT (mark = QUOTAS_<period>) pour chaque client sans quota, ou remplace
    *   les lignes du KOT existant.
    * - KTM vide : supprime le KOT existant de chaque client pour cette période.
    */
   const onValidateDeployKTM = useCallback(async (selectedCustomerIds: string[], opts: KTMDeployOptions) => {
      if (!live_order || !isKTMOrder(live_order)) {
         setShowKtmDeployer(false)
         return
      }
      const period = extractPeriodFromKTMMark(live_order.mark ?? null)
      if (!period) {
         toast.error(trans('?Période invalide sur le KTM'), { position: 'top-right', autoClose: 3000, theme: 'colored' })
         setShowKtmDeployer(false)
         return
      }
      setShowKtmDeployer(false)
      setDeployProgress({ label: trans('?Déploiement en cours'), done: 0, total: selectedCustomerIds.length })

      const targetMark = `${KOT_MARK_PREFIX}${period}`
      const ktmLines = live_order.lines ?? []
      const isEmpty = ktmLines.length === 0

      let nbCreated = 0, nbUpdated = 0, nbDeleted = 0, nbSkipped = 0

      for (let i = 0; i < selectedCustomerIds.length; i++) {
         const cid = selectedCustomerIds[i]
         try {
            const existing = await findKOTByPeriod(cid, period)
            if (isEmpty) {
               if (existing?.id) {
                  await deleteOrder(existing.id)
                  nbDeleted++
               } else {
                  nbSkipped++
               }
            } else {
               if (existing?.id) {
                  const noOpt = !opts.replaceExistingQty && !opts.addNewLines && !opts.removeAbsentLines
                  if (noOpt) {
                     nbSkipped++
                  } else {
                     const merged = mergeKTMIntoKOTLines(existing.lines ?? [], ktmLines, opts)
                     await updateOrder(existing.id, { lines: merged })
                     nbUpdated++
                  }
               } else {
                  const new_order = makeTemplateOrder(cid)
                  new_order.type = type_order.retail_quota as any
                  new_order.mark = targetMark
                  new_order.lines = ktmLines.map(l => ({ sku: l.sku, qty: l.qty }))
                  await createOrder(new_order, { quiet: true })
                  nbCreated++
               }
            }
         } catch (err) {
            console.error(`Deploy KTM sur ${cid} :`, err)
         }
         setDeployProgress({ label: trans('?Déploiement en cours'), done: i + 1, total: selectedCustomerIds.length })
      }

      setDeployProgress(null)

      const parts: string[] = []
      if (nbCreated) parts.push(`${nbCreated} ${trans('?créé', nbCreated)}`)
      if (nbUpdated) parts.push(`${nbUpdated} ${trans('?mis à jour', nbUpdated)}`)
      if (nbDeleted) parts.push(`${nbDeleted} ${trans('?supprimé', nbDeleted)}`)
      if (nbSkipped) parts.push(`${nbSkipped} ${trans('?ignoré', nbSkipped)}`)
      toast.success(`${trans('?Déploiement terminé')} : ${parts.join(', ') || '—'}`, { position: 'top-right', autoClose: 3500, theme: 'colored' })
   }, [live_order, isKTMOrder, extractPeriodFromKTMMark, findKOTByPeriod, KOT_MARK_PREFIX, deleteOrder, updateOrder, makeTemplateOrder, createOrder, type_order.retail_quota, trans])

   const onConfirmUnDeployOK = useCallback(async () => {
      if (!unDeployKtm) return
      const period = extractPeriodFromKTMMark(unDeployKtm.mark ?? null)
      if (!period) {
         toast.error(trans('?Période invalide sur le KTM'), { position: 'top-right', autoClose: 3000, theme: 'colored' })
         setUnDeployKtm(null)
         setUnDeployAffected([])
         setUnDeployCheckedIds([])
         return
      }
      const checkedSet = new Set(unDeployCheckedIds)
      const targets = unDeployAffected.filter(c => checkedSet.has(c.id!))
      setUnDeployKtm(null)
      setUnDeployAffected([])
      setUnDeployCheckedIds([])
      setDeployProgress({ label: trans('?Suppression du déploiement en cours'), done: 0, total: targets.length })

      let nbDeleted = 0
      for (let i = 0; i < targets.length; i++) {
         const c = targets[i]
         try {
            const existing = await findKOTByPeriod(c.id!, period)
            if (existing?.id) {
               await deleteOrder(existing.id)
               nbDeleted++
            }
         } catch (err) {
            console.error(`UnDeploy KTM sur ${c.id} :`, err)
         }
         setDeployProgress({ label: trans('?Suppression du déploiement en cours'), done: i + 1, total: targets.length })
      }

      setDeployProgress(null)
      toast.success(`${trans('?Déploiement terminé')} : ${nbDeleted} ${trans('?supprimé', nbDeleted)}`, { position: 'top-right', autoClose: 3500, theme: 'colored' })
   }, [unDeployKtm, unDeployAffected, unDeployCheckedIds, extractPeriodFromKTMMark, findKOTByPeriod, deleteOrder, trans])

   function onValidateEditContremarque(text) {
      // Pour les KOT/KTM, on force le préfixe QUOTAS_
      let mark = text
      if ((isKOTOrder(live_order) || isKTMOrder(live_order)) && !text?.startsWith(KOT_MARK_PREFIX)) {
         mark = KOT_MARK_PREFIX + text
      }
      setIsContremarqueEditorVisible(false)
      updateOrder(live_order.id, {
         mark
      })
   }

   const onValidateQuotaClone = useCallback(async (mark: string) => {
      setIsQuotaCloneEditorVisible(false)
      const new_id = await cloneOrder(live_order?.id, null, mark)
      if (new_id) {
         setOrderIdAsCurrent(new_id)
         navigate(`/order-detail?id=${new_id}`, { replace: false })
         toast.success(transWithParams('?order_cloned', [new_id]), {
            position: 'top-right',
            autoClose: 2500,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            theme: 'colored'
         })
      }
   }, [cloneOrder, live_order?.id, navigate, setOrderIdAsCurrent, transWithParams])

   function onCancelQuotaClone() {
      setIsQuotaCloneEditorVisible(false)
   }

   const onEditComment = useCallback(() => {
      if (!closeAllDropDowns()) {
         setIsCommentEditorVisible(true)
      }
   }, [closeAllDropDowns])

   function onCancelEditComment() {
      setIsCommentEditorVisible(false)
   }

   function onValidateEditComment(text) {
      setIsCommentEditorVisible(false)
      updateOrder(live_order.id, {
         comment: text
      })
   }

   function onCancelPickMailAddress() {
      setIsMailAddressPickerVisible(false)
   }

   function onValidatePickMailAddress(arr_emails, message) {
      console.log(arr_emails)
      setIsMailAddressPickerVisible(false)

      // Type repris de l'ordre : ECR/ECF utilisent le template _retail (col Disc., total remisé) côté genpdf
      awPushPDF(live_order?.type ?? 'CDE', live_order, arr_emails, message)
   }

   function goOrdersPage() {
      navigate('/orders', { replace: true })
   }

   function goCustomer() {
      navigate(`/customer-detail?id=${live_order.customer_id}`, { replace: true })
   }

   function leaveOrder() {
      setCurOrder(null)
   }

   function cancelSignature() {
      setIsSignatureVisible(false)
   }

   function okSignature(sig) {
      setIsSignatureVisible(false)
      updateOrder(live_order?.id, {
         signature: sig
      })
   }

   // console.log('>>>LIVE_ORDER', live_order);

   return (
      <Fragment>
         <Menu page="orders" />
         <div className={styles.order_detail} onClick={doNothing}>
            {searchBar}
            <div className={styles.content}>
               <div className={styles.header_bg}>
                  <div className={styles.header}>
                     <div className={styles.order_path}>
                        <FontAwesomeIcon icon={isKOTOrder(live_order) ? faScaleBalanced : isKTMOrder(live_order) ? faObjectGroup : isRetailOrder(live_order) ? faBox : faFileLines} />
                        <Link onClick={goOrdersPage}>{trans('?Commande', true)}</Link>
                        <FontAwesomeIcon icon={faAngleRight} />
                        {(live_order?.customer_id?.startsWith(glob_const.prefix_ktm) || live_order?.customer_id?.startsWith(glob_const.prefix_prospect))
                           ? <span style={{ fontStyle: 'italic' }}>{customer?.name}</span>
                           : retailRole === 'client'
                              // user-client : pas d'accès à la fiche client → nom non cliquable.
                              ? <span>{customer?.name}</span>
                              : <Link onClick={goCustomer}>{customer?.name}</Link>
                        }
                        <FontAwesomeIcon icon={faAngleRight} />
                        <span># {live_order?.id}</span>
                        {live_order?.signature && (
                           <div className={styles.order_signed} style={{ cursor: 'pointer' }} onClick={() => setIsSignatureVisible(true)}>
                              <FontAwesomeIcon icon={faSignatureBold} />
                           </div>
                        )}
                        {!isReadOnly && (
                           <>
                              <div className={styles.sync_status}>
                                 {/* User-client retail en attente de validation : loupe-user au lieu du nuage (cf. hideRetailWorkflow) */}
                                 {live_order?.status !== order_status.new && live_order?.status !== order_status.new_mgr && live_order?.status !== order_status.locked4sync && <FontAwesomeIcon className={styles.green} icon={isUnderRetailReview ? faUserMagnifyingGlass : faCloud} />}
                                 {live_order?.status === order_status.locked4sync && <FontAwesomeIcon className={styles.orange} icon={faCloudXmark} />}
                                 {!hideRetailWorkflow && (live_order?.status === order_status.wait_n1) && <span className={styles.green}>N1</span>}
                                 {!hideRetailWorkflow && (live_order?.status === order_status.wait_n2) && <span className={styles.green}>N2</span>}
                                 {!hideRetailWorkflow && _isRetail && (live_order?.status === order_status.locked || live_order?.status === order_status.wait_m3) && <span className={styles.green}>M3</span>}
                              </div>
                              <div className={styles.active_order}>
                                 {curOrder === live_order?.id && !isValidationMode && (
                                    <Button small secondary red onClick={leaveOrder}>
                                       {trans('?Quitter commande')}
                                    </Button>
                                 )}
                                 {curOrder !== live_order?.id && !isOrderSubmittedOrLocked(live_order?.status) && canWriteKOT(live_order, roleForOrder) && (
                                    <Button small onClick={makeActive}>
                                       {trans('?Sélectionner')}
                                    </Button>
                                 )}
                              </div>
                           </>
                        )}
                        {isReadOnly && live_order?.status !== order_status.done_m3 && (
                           <>
                              <div className={styles.sync_status}>
                                 {/* User-client retail en attente de validation : loupe-user au lieu du nuage (cf. hideRetailWorkflow) */}
                                 {live_order?.status !== order_status.new && live_order?.status !== order_status.new_mgr && live_order?.status !== order_status.deleted && live_order?.status !== order_status.locked4sync && <FontAwesomeIcon className={styles.green} icon={isUnderRetailReview ? faUserMagnifyingGlass : faCloud} />}
                                 {live_order?.status === order_status.locked4sync && <FontAwesomeIcon className={styles.orange} icon={faCloudXmark} />}
                                 {live_order?.status === order_status.deleted && <FontAwesomeIcon className={styles.red} icon={faTrashXmark} />}
                                 {!hideRetailWorkflow && (live_order?.status === order_status.wait_n1) && <span className={styles.green}>N1</span>}
                                 {!hideRetailWorkflow && (live_order?.status === order_status.wait_n2) && <span className={styles.green}>N2</span>}
                                 {!hideRetailWorkflow && _isRetail && (live_order?.status === order_status.locked || live_order?.status === order_status.wait_m3) && <span className={styles.green}>M3</span>}
                              </div>
                           </>
                        )}
                     </div>
                     <div className={styles.order_header}>
                        <div
                           className={styles.order_type}
                           onClick={(evt) => {
                              if (!isReadOnly && isSelected && !isKOTOrKTM(live_order)) toggleShowDropdownMenuOrderType(evt)
                           }}
                        >
                           {live_order?.type === type_order.commande && <FontAwesomeIcon icon={faGemProSolid} />}
                           {live_order?.type === type_order.implant && <FontAwesomeIcon icon={faShelves} />}
                           {live_order?.type === type_order.confie && <FontAwesomeIcon icon={faHandHoldingBox} />}
                           {live_order?.type === type_order.triangulaire && <FontAwesomeIcon icon={faRecycle} />}
                           {live_order?.type === type_order.devis && <FontAwesomeIcon icon={faFilePen} />}
                           {live_order?.type === type_order.retail_interne && <FontAwesomeIcon icon={faBox} />}
                           {live_order?.type === type_order.retail_externe && <FontAwesomeIcon icon={faBox} />}
                           {isKOTOrder(live_order) && <FontAwesomeIcon icon={faScaleBalanced} />}
                           {isKTMOrder(live_order) && <FontAwesomeIcon icon={faObjectGroup} />}
                           <span>{live_order?.type}</span>
                           {isMenuOrderTypeVisible && dropdownMenuOrderType}
                        </div>
                        <div className={styles.order_id}>
                           <span>{trans('?N° Cde')}</span>
                           <span>{live_order?.id}</span>
                        </div>
                        <div
                           className={styles.order_mark}
                           onClick={() => {
                              if (!isReadOnly && isSelected) onEditContremarque()
                           }}
                        >
                           <span className={isReadOnly ? '' : (live_order?.mark ?? '').trim().length === 0 ? styles.disabled : styles.enabled}>
                              {trans('?Contremarque')}
                              {!isReadOnly && isSelected && <FontAwesomeIcon icon={faPenToSquare} />}
                           </span>
                           <span>{live_order?.mark ?? ''}</span>
                        </div>
                        {!isKOTOrKTM(live_order) && (
                           <div className={styles.order_date}>
                              <span>
                                 {trans('?Date')}
                                 {!isReadOnly && isSelected && <FontAwesomeIcon icon={faPenToSquare} />}
                              </span>
                              {(isReadOnly || !isSelected) && <span>{moment(live_order?.date).format('YYYY-MM-DD')}</span>}
                              {!isReadOnly && isSelected && (
                                 <span>
                                    <DatePicker
                                       selected={moment(live_order?.date).toDate()}
                                       locale={curLang === 'fr' ? 'fr' : 'en-US'}
                                       showWeekNumbers={showWeeksNum}
                                       calendarStartDay={1} // forcer début de semaine = Lundi
                                       onSelect={handleOrderDateSelect} //when day is clicked
                                       onChange={/*handleDateChange*/ () => {}} //only when value has changed
                                       customInput={<CustomDate text={live_order?.date} />}
                                    />
                                 </span>
                              )}
                           </div>
                        )}
                        {!isKOTOrKTM(live_order) && (
                           <div className={styles.order_delivery}>
                              <span>
                                 {trans('?Livraison')}
                                 {!isReadOnly && isSelected && <FontAwesomeIcon icon={faPenToSquare} />}
                              </span>
                              {(isReadOnly || !isSelected) && <span>{moment(live_order?.delivery).format('YYYY-MM-DD')}</span>}
                              {!isReadOnly && isSelected && (
                                 <span>
                                    <DatePicker
                                       selected={moment(live_order?.delivery).toDate()}
                                       locale={curLang === 'fr' ? 'fr' : 'en-US'}
                                       showWeekNumbers={showWeeksNum}
                                       calendarStartDay={1} // forcer début de semaine = Lundi
                                       minDate={moment(live_order?.date).add(1, 'day').toDate()}
                                       onSelect={handleDeliveryDateSelect} //when day is clicked
                                       onChange={/*handleDateChange*/ () => {}} //only when value has changed
                                       customInput={<CustomDate text={live_order?.delivery} />}
                                    />
                                 </span>
                              )}
                           </div>
                        )}
                        {!isReadOnly && !isProspect && !isKOTOrKTM(live_order) && (
                           <div
                              className={styles.order_addresses}
                              onClick={(evt) => {
                                 if (isSelected || isValidationMode) toggleShowAddressPicker(evt)
                              }}
                           >
                              <span>
                                 {trans('?Adresse', !isRetailOrder(live_order) && live_order?.type !== type_order.confie ? true : null)}
                                 {!isReadOnly && (isSelected || isValidationMode) && <FontAwesomeIcon icon={faPenToSquare} />}
                              </span>
                              <div>
                                 {!isRetailOrder(live_order) && (
                                    <span className={!live_order?.addresses?.jewels ? styles.disabled : ''}>
                                       <FontAwesomeIcon icon={faGem} />
                                    </span>
                                 )}
                                 {live_order?.type !== type_order.confie && (
                                    <span className={!live_order?.addresses?.ecrins ? styles.disabled : ''}>
                                       <FontAwesomeIcon icon={faBox} />
                                    </span>
                                 )}
                              </div>
                           </div>
                        )}
                        <div className={styles.order_total}>
                           <span>{itemsCountForOrder > 0 ? `${formatNumber(itemsCountForOrder)} ${trans('?article', itemsCountForOrder)}` : trans('?Total')}</span>
                           {/* Retail : prix des lignes = prix PUBLIC (PPU) → devise publique (ex. QAR), pas la cession (EUR). */}
                           <span>{formatCESPrice(totalForOrder, currency)}</span>
                        </div>
                        {/* Dépôt du client : bloc/colonne dédié(e), visible pour admin + N1 (de ce customer) uniquement */}
                        {_isRetail && (roleForOrder.isAdmin || roleForOrder.isN1) && customer?.depot_retail && (
                           <div className={styles.order_depot}>
                              <span>{trans('?Dépôt')}</span>
                              <span>{customer.depot_retail} — {glob_const.retail_depot_names[customer.depot_retail] ?? customer.depot_retail}</span>
                           </div>
                        )}
                        {isSelected && (
                           <Button secondary onClick={toogleShowDropdownMenuGlobal}>
                              {trans('?Action', true)}
                              {showDropdownMenuGlobal && dropdownMenuGlobal}
                           </Button>
                        )}
                        {/* <div className={styles.btn_actions} onClick={toogleShowDropdownMenuGlobal} >
                           <FontAwesomeIcon icon={faGear} />
                           {showDropdownMenuGlobal && dropdownMenuGlobal}
                        </div> */}
                     </div>
                     <div
                        className={styles.order_comment}
                        onClick={() => {
                           if (!isReadOnly && isSelected) onEditComment()
                        }}
                     >
                        <span>
                           {trans('?Commentaire')}
                           {!isReadOnly && isSelected && <FontAwesomeIcon icon={faPenToSquare} />}
                        </span>
                        <span>{live_order?.comment}</span>
                     </div>
                  </div>
               </div>
               {isValidationMode && live_order ? (
                  <RetailValidationTable
                     key={validationTableKey}
                     ref={validationTableRef}
                     order={live_order}
                     validateMode={live_order.status === order_status.wait_n2 ? 'n2' : 'n1'}
                     mode={isDraftMode ? 'draft' : 'validation'}
                     onValidated={() => navigate('/orders?tab=unsync', { replace: true })}
                     onClose={() => navigate(isDraftMode ? '/orders?tab=unsync' : '/orders?tab=pending', { replace: true })}
                     onFinalValidation={() => requestFinalValidation(live_order, () => {
                        setCurOrder(null)
                        navigate('/orders?tab=unsync', { replace: true })
                     })}
                     onReturnToClient={() => requestReturnToClient(live_order, () => {
                        setCurOrder(null)
                        navigate('/orders?tab=unsync', { replace: true })
                     })}
                  />
               ) : (
               <div className={styles.detail}>
                  <table>
                     <thead>
                        {(isRetailOrder(live_order) || isKOTOrKTM(live_order)) && (
                           <tr>
                              <th style={{ width: '40px' }}>#</th>
                              <th style={{ width: '110px' }}>{trans('?SKU')}</th>
                              <th>{trans('?Libellé')}</th>
                              {isRetailOrder(live_order) && (
                                 <th className={styles.col_stock} style={{ textAlign: 'left' }}>{trans('?Stock')}</th>
                              )}
                              <th style={{ width: '60px', textAlign: 'right' }}>{trans('?Qté')}</th>
                              {(isKOTOrKTM(live_order) || hasActiveKOT) && !isKOTOrder(live_order) && (
                                 <th style={{ width: '110px', textAlign: 'right', whiteSpace: 'pre-line', lineHeight: 1.1 }}>
                                    {trans('?Quota restant').replace(' ', '\n')}
                                    <span style={{ display: 'block', fontSize: '0.75em', fontWeight: 'normal', opacity: 0.7 }}>{trans('?(hors cette cde)')}</span>
                                 </th>
                              )}
                              {live_order?.type === type_order.retail_externe && (hasDisplayableDiscount || canEditDiscount()) && (
                                 <th style={{ textAlign: 'right' }}>
                                    {trans('?Remise')}
                                    {canEditDiscount() && isSelected && <FontAwesomeIcon icon={faPenToSquare} />}
                                 </th>
                              )}
                              <th style={{ width: '90px', textAlign: 'right' }}>{trans('?Prix')}</th>
                              {!isReadOnly && isSelected && <th></th> /* Actions*/}
                           </tr>
                        )}
                        {!isRetailOrder(live_order) && !isKOTOrKTM(live_order) && (
                           <tr>
                              <th>#</th>
                              <th>{trans('?Modèle')}</th>
                              <th>{trans('?Couleur')}</th>
                              <th>{trans('?Taille')}</th>
                              <th>{trans('?Libellé')}</th>
                              <th>
                                 {trans('?Commentaire')}
                                 {!isReadOnly && isSelected && <FontAwesomeIcon icon={faPenToSquare} />}
                              </th>
                              <th>{trans('?Qté')}</th>
                              <th>{trans('?À livrer')}</th>
                              <th style={{ textAlign: 'right' }}>{trans('?Prix')}</th>
                              {!isReadOnly && isSelected && <th></th> /* Actions*/}
                           </tr>
                        )}
                     </thead>
                     <tbody>{lines}</tbody>
                  </table>
               </div>
               )}
               {/* <div className={styles.footer_bg}>
                  <div className={styles.footer}>
                     <span>{trans('?Affichage de')} xxxx </span>
                  </div>
               </div> */}
            </div>
         </div>
         {isQtyPickerVisible && (isRetailOrder(live_order) || isKOTOrKTM(live_order)) && <QtyPickerRetail customer={live_order?.customer_id} model={editedSKU} qty={editedQty} onHide={hideQtyPicker} onUpdate={updateRetailLines} />}
         {isQtyPickerVisible && !isRetailOrder(live_order) && !isKOTOrKTM(live_order) && (
            <QtyPicker customer={live_order?.customer_id} model={editedModel} color={editedColor} size={editedSize} multi={live_order?.type === TRI_TYPE ? undefined : editedAllVariations} orderType={live_order?.type} qty={editedQty} onHide={hideQtyPicker} onUpdate={updateLines} />
         )}
         {isLineCommentEditorVisible && (
            <CommentEditor
               title={trans('?Commentaire ligne')}
               icon={<FontAwesomeIcon icon={faMemo} />}
               value={editedLineComment}
               onCancel={onCancelEditLineComment}
               onValidate={onValidateEditLineComment}
               top={'20%'}
               minWidth={'30%'}
               maxWidth={'50%'}
               lines={5}
               maxLength={200}
            />
         )}
         {isLineDiscountEditorVisible && (
            <DiscountEditor
               title={trans('?Remise ligne')}
               icon={<FontAwesomeIcon icon={faPercent} />}
               value={editedLineDiscount}
               onCancel={onCancelEditLineDiscount}
               onValidate={onValidateEditLineDiscount}
               top={'20%'}
               minWidth={'25%'}
               maxWidth={'40%'}
            />
         )}
         {isBulkDiscountEditorVisible && (
            <DiscountEditor
               title={trans('?Remise globale')}
               icon={<FontAwesomeIcon icon={faPercent} />}
               value={live_order?.lines?.[0]?.discount ?? 0}
               onCancel={onCancelBulkDiscount}
               onValidate={onValidateBulkDiscount}
               top={'20%'}
               minWidth={'25%'}
               maxWidth={'40%'}
            />
         )}
         {isCommentEditorVisible && (
            <CommentEditor
               title={trans('?Commentaire')}
               icon={<FontAwesomeIcon icon={faMemo} />}
               value={live_order?.comment}
               onCancel={onCancelEditComment}
               onValidate={onValidateEditComment}
               top={'20%'}
               minWidth={'30%'}
               maxWidth={'50%'}
               lines={5}
               maxLength={200}
            />
         )}
         {isMailAddressPickerVisible && <MailAddressPicker customer={live_order?.customer_id} onCancel={onCancelPickMailAddress} onValidate={onValidatePickMailAddress} top={'20%'} minWidth={'30%'} maxWidth={'50%'} />}

         {isAddressPickerVisible && (
            <AddressPicker
               title={trans('?Adresse de livraison', !isRetailOrder(live_order) && live_order?.type !== type_order.confie ? true : null)}
               icon={<FontAwesomeIcon icon={faMemo} />}
               order={live_order}
               onLocalUpdate={isValidationMode ? (addresses) => updateOrderLocally(live_order.id, { addresses }) : undefined}
               onClose={() => setIsAddressPickerVisible(false)}
               top={'20%'}
            />
         )}
         {isContremarqueEditorVisible && !isKOTOrder(live_order) && !isKTMOrder(live_order) && (
            <CommentEditor
               title={trans('?Contremarque')}
               icon={<FontAwesomeIcon icon={faTag} />}
               value={live_order?.mark}
               onCancel={onCancelEditContremarque}
               onValidate={onValidateEditContremarque}
               top={'20%'}
               minWidth={'30%'}
               maxWidth={'50%'}
               lines={1}
               maxLength={20}
            />
         )}
         {isContremarqueEditorVisible && isKOTOrder(live_order) && (
            <QuotaMarkEditor
               value={live_order?.mark}
               isKOT={true}
               existingMarks={existingKOTMarksForCustomer}
               onCancel={onCancelEditContremarque}
               onValidate={onValidateEditContremarque}
               onViewExisting={onViewExistingQuota}
               top={'20%'}
               minWidth={'30%'}
               maxWidth={'50%'}
            />
         )}
         {isContremarqueEditorVisible && isKTMOrder(live_order) && (
            <QuotaMarkEditor
               value={live_order?.mark}
               isKOT={false}
               onCancel={onCancelEditContremarque}
               onValidate={onValidateEditContremarque}
               existingMarks={existingKTMMarks}
               onViewExisting={onViewExistingQuota}
               top={'20%'}
               minWidth={'30%'}
               maxWidth={'50%'}
            />
         )}
         {isQuotaCloneEditorVisible && (isKOTOrder(live_order) || isKTMOrder(live_order)) && (
            <QuotaMarkEditor
               value={live_order?.mark}
               isKOT={isKOTOrder(live_order)}
               existingMarks={isKOTOrder(live_order) ? existingKOTMarksForCustomer : existingKTMMarks}
               onCancel={onCancelQuotaClone}
               onValidate={onValidateQuotaClone}
               onViewExisting={onViewExistingQuota}
               top={'20%'}
               minWidth={'30%'}
               maxWidth={'50%'}
            />
         )}
         {isConfirmVisible && <Confirm yesno onOK={onConfirmOK} onCancel={onConfirmCancel} title={trans('?Suppression')} text={trans(confirmType === confirm_type.conf_delete_line ? '?confirmer_suppression_ligne' : (isKTMOrder(live_order) || live_order?.customer_id?.startsWith(glob_const.prefix_prospect)) ? '?confirmer_suppression_modele' : '?confirmer_suppression_bdc')} />}
         {duplicateLineDialog && (
            <Confirm
               title={trans('?SKU déjà présent')}
               text={
                  <>
                     <div>{transWithParams('?sku_duplicate_info', [duplicateLineDialog.line.sku, duplicateLineDialog.existingQty])}</div>
                     <div>{transWithParams('?sku_duplicate_question', [duplicateLineDialog.line.qty, duplicateLineDialog.existingQty + duplicateLineDialog.line.qty])}</div>
                  </>
               }
               onOK={onReplaceDuplicate}
               onCancel={onCancelDuplicate}
               okLabel={trans('?Remplacer')}
               middleButton={{ label: trans('?Cumuler'), onClick: onCumulateDuplicate }}
            />
         )}
         {showValidateConfirm && (
            <ReliquatConfirm
               title={trans(validateMode === 'n2' ? '?Soumettre' : '?Validation finale')}
               lines={refusedLinesForPopup}
               checked={checkedRefusedLines}
               onToggle={(i) => setCheckedRefusedLines(prev => prev.map((v, j) => j === i ? !v : v))}
               onOK={onValidateConfirmOK}
               onCancel={onValidateConfirmCancel}
            />
         )}
         {finalValidationPopups}
         {returnToClientPopups}
         {submitPopups}
         {isSignatureVisible && <Signature readOnly={curOrder !== live_order?.id} onCancel={cancelSignature} onOK={okSignature} sig={live_order?.signature} />}
         <input type="file" accept=".csv,.xlsx" ref={fileInputRef} style={{ display: 'none' }} onChange={onFileInputChange} />
         <input type="file" accept=".json" ref={jsonImportRef} style={{ display: 'none' }} onChange={onJSONImportFileChange} />
         {importJSONOrder && (
            <Confirm
               destructive
               title={trans('?Restaurer une sauvegarde')}
               onOK={onConfirmImportJSON}
               onCancel={() => setImportJSONOrder(null)}
               okLabel={trans('?Écraser')}
               minWidth={'35%'}
               maxWidth={'55%'}
            >
               <div>{trans('?La commande courante sera écrasée par le contenu du fichier.')}</div>
               <div style={{ fontSize: '0.85em', color: '#888', marginTop: '4px' }}>{trans("?L'identifiant de la commande ne sera pas modifié.")}</div>
               <div style={{ margin: '10px 0', padding: '10px', background: '#f8f8f8', borderRadius: '6px', fontSize: '0.9em' }}>
                  <div><strong>{trans('?N° Cde')}</strong> : {importJSONOrder.id}</div>
                  <div><strong>{trans('?Client')}</strong> : {importJSONOrder.customer_id}</div>
                  <div><strong>{trans('?Type')}</strong> : {importJSONOrder.type}</div>
                  <div><strong>{trans('?Date')}</strong> : {importJSONOrder.date}</div>
                  {importJSONOrder.mark && <div><strong>{trans('?Contremarque')}</strong> : {importJSONOrder.mark}</div>}
                  {importJSONOrder.comment && <div><strong>{trans('?Commentaire')}</strong> : {importJSONOrder.comment}</div>}
               </div>
               <div style={{ fontSize: '0.85em', fontWeight: 600, marginBottom: '4px' }}>
                  {importJSONOrder.lines?.length ?? 0} {trans('?ligne', importJSONOrder.lines?.length ?? 0)}
               </div>
               <div style={{ maxHeight: '30vh', overflowY: 'auto', border: '1px solid #eee', borderRadius: '6px', padding: '6px 10px', fontSize: '0.85em', fontFamily: 'monospace' }}>
                  {importJSONOrder.lines?.map((l, i) => (
                     <div key={i}>{l.sku} x{l.qty}</div>
                  ))}
               </div>
            </Confirm>
         )}
         {showImportModeConfirm && (
            <Confirm
               title={trans("?Choisir le mode d'import")}
               text={`${pendingImportLines.length} ligne(s) à importer`}
               onCancel={() => { setShowImportModeConfirm(false); setPendingImportLines([]); setImportOptReplace(true); setImportOptCumul(false) }}
               onOK={doImport}
               minWidth={'30%'}
               maxWidth={'44%'}
               okLabel={trans("?Valider")}
            >
               <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', padding: '12px 0 0' }}>
                  <Checkbox
                     checked={importOptReplace ? CheckboxStates.Checked : CheckboxStates.Unchecked}
                     caption={trans("?Remplacer l'existant")}
                     onChange={(state) => { setImportOptReplace(state === CheckboxStates.Checked); if (state === CheckboxStates.Checked) setImportOptCumul(false) }}
                  />
                  <Checkbox
                     checked={importOptCumul ? CheckboxStates.Checked : CheckboxStates.Unchecked}
                     caption={trans("?Cumuler les quantités")}
                     disabled={importOptReplace}
                     onChange={(state) => setImportOptCumul(state === CheckboxStates.Checked)}
                  />
               </div>
            </Confirm>
         )}
         {showKtmDeployer && live_order && isKTMOrder(live_order) && (
            <KTMDeployer
               ktm={live_order}
               onCancel={() => setShowKtmDeployer(false)}
               onValidate={onValidateDeployKTM}
               top={'10%'}
               minWidth={'50%'}
               maxWidth={'80%'}
            />
         )}
         {unDeployKtm && (
            <Confirm
               destructive
               title={trans('?Supprimer le déploiement')}
               onOK={onConfirmUnDeployOK}
               onCancel={() => { setUnDeployKtm(null); setUnDeployAffected([]); setUnDeployCheckedIds([]) }}
               enableOK={unDeployCheckedIds.length > 0}
               okLabel={trans('?Supprimer')}
               minWidth={'40%'}
               maxWidth={'60%'}
            >
               {unDeployAffected.length > 0 ? (
                  <>
                     <div>{transWithParams('?Les clients suivants ont des quotas pour la période %1.', [extractPeriodFromKTMMark(unDeployKtm.mark ?? null) ?? ''])}</div>
                     <div>{trans('?Les quotas des clients sélectionnés seront supprimés :')}</div>
                  </>
               ) : (
                  <div>{trans('?Aucun client concerné pour cette période')}</div>
               )}
               {unDeployAffected.length > 0 && (() => {
                  const total = unDeployAffected.length
                  const nbSel = unDeployCheckedIds.length
                  const masterState = nbSel === 0 ? CheckboxStates.Unchecked : nbSel === total ? CheckboxStates.Checked : CheckboxStates.Undefined
                  const toggleMaster = () => {
                     if (masterState === CheckboxStates.Checked) setUnDeployCheckedIds([])
                     else setUnDeployCheckedIds(unDeployAffected.map(c => c.id!))
                  }
                  return (
                     <div style={{ maxHeight: '40vh', overflowY: 'auto', margin: '12px 0', border: '1px solid #eee', borderRadius: '6px' }}>
                        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.9em' }}>
                           <thead>
                              <tr style={{ background: '#fafafa', position: 'sticky', top: 0, zIndex: 1, boxShadow: '0 2px 4px rgba(0,0,0,0.1)' }}>
                                 <th style={{ padding: '6px 10px', width: 40, textAlign: 'left', background: '#fafafa' }} onClick={e => e.stopPropagation()}>
                                    <Checkbox
                                       small
                                       three_states
                                       checked={masterState}
                                       onChange={toggleMaster}
                                    />
                                 </th>
                                 <th colSpan={2} style={{ padding: '6px 10px', textAlign: 'left', fontWeight: 600, color: '#666', background: '#fafafa' }}>
                                    {trans('?Sélection de')} {nbSel} / {total} {lowtrans('?Client', total)}
                                 </th>
                              </tr>
                           </thead>
                           <tbody>
                              {unDeployAffected.map(c => {
                                 const checked = unDeployCheckedIds.includes(c.id!)
                                 const toggle = () => setUnDeployCheckedIds(cur => checked ? cur.filter(id => id !== c.id) : [...cur, c.id!])
                                 return (
                                    <tr key={c.id} style={{ borderBottom: '1px solid #eee', cursor: 'pointer' }} onClick={toggle}>
                                       <td style={{ padding: '6px 10px', width: 40 }}>
                                          <Checkbox
                                             small
                                             checked={checked ? CheckboxStates.Checked : CheckboxStates.Unchecked}
                                             onChange={toggle}
                                          />
                                       </td>
                                       <td style={{ padding: '6px 10px', fontFamily: 'monospace', color: '#666', width: 80 }}>{c.id}</td>
                                       <td style={{ padding: '6px 10px' }}>{c.name}</td>
                                    </tr>
                                 )
                              })}
                           </tbody>
                        </table>
                     </div>
                  )
               })()}
            </Confirm>
         )}
         {deployProgress && (
            <ProgressPopup title={deployProgress.label} done={deployProgress.done} total={deployProgress.total} />
         )}
         <ToastContainer />
      </Fragment>
   )
}

export default OrderDetail
